export default function ($translateProvider) {
	'ngInject';

	$translateProvider
		.translations('bg', {
			'VERSION': '1.2.0',
			'HELLO': 'Здравейте, ',
			'CUSTOM_SOFTWARE_DEVELOPMENT_WOLLOW': 'Изработка на софтуер от Wollow Soft',
			'ADD_NEW_CITY': 'Добави нов град',
			'TIMER_LOGOUT': 'Вие автоматично излязохте от системата поради продължителна неактивност',
			'ADD': 'Добави',
			'AMOUNT': 'Сума',
			'ADDRESS': 'Адрес',
			'AFTER_POINT': 'Постави след...',
			'ALL_RIGHTS_RESERVED': 'Всички права запазени',
			'AVAILABLE_LINES': 'Въведени линии',
			'ARRIVES': 'Пристига',
			'BASE_CURRENCY': 'Базова валута',
			'BUSES_FROM_LINE': 'Автобуси от линия',
			'BUS': 'Автобус',
			'BUS_SCHEMA_WARNING': 'Местата на схемата може да не отговарят на разположението на седалките в автобуса. Груп ООД запазва правото си да променя номера на мястото по резервация.',
			'BUS_SCHEMA': 'Схема на автобуса',
			'BUSES_GOING_OTHER_DAYS': 'Автобуси на отиване в близките дни:',
			'BUSES_RETURN_OTHER_DAYS': 'Автобуси навръщане в близките дни:',
			'BTN': {
				'ADD': 'Добави',
				'ADD_NEW_BUS': 'Добави автобус',
				'ADD_CITY_BTN': 'Добави град',
				'ADD_NEW_DISCOUNT': 'Добави намаление',
				'ADD_NEW_CITY': 'Добави нов град',
				'ADD_NEW_LINE': 'Добави нова линия',
				'ADD_NEW_STATION': 'Добави нова спирка',
				'ADD_NEW_OFFICE': 'Добави нов офис',
				'ADD_NEW_AGENT': 'Добави нов агент',
				'ADD_NEW_PROMOTION': 'Добави нова промоция',
				'ADD_NEW_ADMINISTRATOR': 'Добави нов администратор',
				'ADD_NEW_CURRENCY': 'Добави нова валута',
				'ADD_STATION': 'Добави спирка',
				'ADD_LINES': 'Добави линии',
				'BACK': 'Назад',
				'BACK_TO_LAST_PAGE': 'Върни се обратно',
				'CANCEL': 'Откажи',
				'CANCEL_ALIAS': 'Анулирай',
				'CHANGE_DATA_GOING': 'Променете данни за връщане',
				'CHANGE_DATA_RETURN': 'Променете данни за отиване',
				'CHANGE_PASSWORD': 'Променете паролата',
				'CHANGE_BUS': 'Променете автобуса',
				'LOGIN': 'Вход',
				'NEW_CLIENT': 'Нов клиент',
				'SAVE': 'Запази',
				'SAVE_CHANGES': 'Запази промените',
				'SAVE_LINE': 'Запиши линията',
				'SEARCH': 'Търси',
				'EDIT': 'Редактирай',
				'REMOVE': 'Изтрий',
				'RESERVE': 'Резервирай',
				'PRINT': 'Принтирай',
				'PREVIEW': 'Преглед',
				'BUY': 'Купи',
				'EDIT_SEAT': 'Редактирай място',
				'CONTINUE': 'Продължи',
				'DELETE_RESERVATION': 'Изтрий резервацията',
				'CLOSE': 'Затвори'
			},
			'CURRENCIES': {
				'BGN': 'лв',
				'EUR': '€'
			},
			'CANCELED': 'Анулиран',
			'CITY': 'Град',
			'COPY': 'Копирай',
			'CODE': 'Код',
			'COMMISSION': 'Комисиона',
			'ACCOUNTING_PRICE': 'Цена за отчет',
			'COPY_LOCKED_SEATS': 'Копирам заключените места за друга дата',
			'COMPLETED_ROUTES': 'Попълнени маршрути:',
			'CURRENT_PASSWORD': 'Настояща парола',
			'CHOOSE': 'Избери',
			'CHOOSE_LINE': 'Изберете линия',
			'CHOOSE_GOING_BUS': 'Изберете автобус на заминаване:',
			'CHOOSE_RETURN_BUS': 'Изберете автобус навръщане:',
			'CHOOSE_STATIONS_TO_CHANGE_SEATS': 'Моля, изберете спирки, за да редактирате местата на автобуса',
			'CHOOSE_BUS_AND_DATE_TO_PICK_STATIONS': 'Моля, изберете автобус и дата, за да може да изберете спирки',
			'CLIENT_DATA': 'Данни за клиента:',
			'CLEAR_FIELDS': 'Изчисти полетата',
			'CREATED_BY': 'Разработено от',
			'CREATE_REVERSE_LINE': 'Създай обратна линия',
			'CONFIRM': {
				'EDIT_SEAT': 'Избраната седалка е заета. Желаете ли да я редактирате?',
				'DELETE': 'Сигурни ли сте, че искате да изтриете този запис?',
				'LOCKED_SEATS_NOT_SAVED': 'Имате промени, които не сте запазили. Сигурни ли сте че искате да продължите?',
				'OVERWRITE_LOCKED_SEATS': 'Автобусът на тази дата има вече заключени места. Искате ли да ги презапишете?',
				'CANCEL_TICKET': 'Сигуни ли сте, че искате да анулирате този билет?',
				'CHANGE_STATIONS_LINE': 'Промяната на спирките по линията ще доведе до загуба на автобуси, цени, отчети и билети към тази линия. Сигурни ли сте, че искате да продължите?'
			},
			'DATE': 'Дата',
			'DATE_DEPARTURE': 'Дата на заминаване',
			'DATE_RETURNS': 'Дата на връщане',
			'DATE_FROM': 'Начална дата',
			'FROM_DATE': 'От дата',
			'DATE_TO': 'Крайна дата',
			'DATE_FOR_COPY': 'Дата за копиране',
			'TO_DATE': 'До дата',
			'DAYS': 'Дни',
			'STATISTICS': 'Изведете статистика за период',
			'NO_DATA': 'Няма намерени резултати',
			'SEARCH_TICKET': 'Tърсете билет',
			'SEARCH_LINE': 'Tърсете линия',
			'DESCRIPTION': 'Описание',
			'DESCRIPTION_OF': {
				'bg': 'Описание',
				'en': 'Описание на английски'
			},
			'DEPARTURE': 'Заминава',
			'DEPARTURE_IN': 'Заминава в',
			'ARRIVES_AT': 'Час на пристигане',
			'DEPARTURE_FROM': 'Тръгва от',
			'DELETE_CONFIRM': 'Сигурни ли сте, че искате да изтриете този запис?',
			'DIRECTION': 'Посока',
			'DISCOUNT': 'Намаление',
			'EMAIL': 'Имейл',
			'EMAIL_USERNAME': 'Имейл/Потребителско име',
			'EXCHANGE_RATE': 'Обменен курс',
			'RATIO': 'Съотношение',
			'EDIT': 'Редактирай',
			'EDIT_LINES': 'Редактирай линии',
			'ERRORS': {
				'GENERAL': 'Моля, въведете правилни данни.',
				'MINLENGTH_PASSWORD': 'Паролата трябва да е не по-малко от 6 символа.',
				'MINLENGTH_PASSWORD_CONFIRM': 'Потвърждението на паролата трябва да е не по-малко от 6 символа.',
				'MINLENGTH_NAME': 'Името трябва да е не по-малко от 4 символа.',
				'MINLENGTH_LINE_NAME': 'Името трябва да е не по-малко от 3 символа.',
				'MINLENGTH_DESCRIPTION': 'Описанието трябва да е не по-малко от 3 символа.',
				'MINVALUE_PRICE': 'Минималната стойност на билет трябва да бъде не по-малко от 0.01',
				'MINVALUE_COMMISSION': 'Минималната стойност на комисионната трябва да бъде не по-малко от 0 процента',
				'MAXVALUE_PRICE': 'Максималната стойност на билет трябва да бъде не по-голяма от 10000',
				'MAXLENGTH_PASSWORD': 'Паролата трябва да е не повече от 30 символа.',
				'MAXLENGTH_PASSWORD_CONFIRM': 'Потвърждението на паролата трябва да е не повече от 30 символа.',
				'MAXLENGTH_NAME': 'Името трябва да е не повече от 30 символа.',
				'MAXLENGTH_LINE_NAME': 'Името трябва да е не повече от 40 символа.',
				'MAXLENGTH_DESCRIPTION': 'Описанието трябва да е не повече от 100 символа.',
				'MAXVALUE_COMMISSION': 'Максималната стойнсот на комисионната трябва да бъде не повече от 100 процента.',
				'REQUIRED_ARRIVES_HOUR': 'Моля, въведете час на пристигане в град',
				'REQUIRED_ADDRESS': 'Моля, въведете адрес.',
				'REQUIRED_CITY': 'Моля, изберете град.',
				'REQUIRED_COUNTRY': 'Моля, изберете държава.',
				'REQUIRED_CONFIRM_PASSWORD': 'Моля, потвърдете паролата.',
				'REQUIRED_DATE': 'Моля, изберете дата.',
				'REQUIRED_DAYS': 'Моля, изберете дни.',
				'REQUIRED_DEPARTURE_HOUR': 'Моля, въведете час на заминаване от град',
				'REQUIRED_DESCRIPTION': 'Моля, въведете описание.',
				'REQUIRED_EMAIL': 'Моля, въведете имейл.',
				'REQUIRED_DATA': 'Моля, въведете правилните данни.',
				'REQUIRED_VALID_EMAIL': 'Моля, въведете валиден имейл.',
				'REQUIRED_VALID_DATA': 'Моля, въведете валидни данни.',
				'REQUIRED_VALID_PHONE': 'Моля въведете валиден телефонен номер!',
				'REQUIRED_EXISTING_STATION': 'Моля, изберете една от съществуващите спирки.',
				'REQUIRED_GOING_LINE': 'Моля, изберете линия на отиване.',
				'REQUIRED_GOING_SEAT': 'Моля, изберете място на отиване.',
				'REQUIRED_RETURN_SEAT': 'Моля, изберете място навръщане.',
				'REQUIRED_ID': 'Моля, въведете ЕГН.',
				'REQUIRED_NAME': 'Моля, въведете име.',
				'REQUIRED_RETURN_DATA': 'Моля, въведете данни за връщане.',
				'REQUIRED_RETURN_LINE': 'Моля, изберете линия навръщане.',
				'REQUIRED_NAMES': 'Моля, въведете имена.',
				'REQUIRED_PASSWORD': 'Моля, въведете парола.',
				'REQUIRED_PASSWORD_CONFIRM': 'Моля, въведете потвърждение на паролата.',
				'REQUIRED_PHONE': 'Моля, въведете телефон.',
				'REQUIRED_PRICE': 'Моля, въведете цена на билет',
				'REQUIRED_SEATS': 'Моля, въведете места.',
				'REQUIRED_STATION': 'Моля, въведете спирка.',
				'REQUIRED_STATIONS': 'Моля, въведете повече от една спирка.',
				'REQUIRED_STATUS': 'Моля, изберете статус на билета.',
				'REQUIRED_TICKET_TYPE': 'Моля, изберете типа на билета.',
				'REQUIRED_TELEPHONE': 'Моля въведете телефонен номер',
				'REQUIRED_VALUE': 'Моля, въведете стойност.',
				'REQUIRED_DISCOUNT_TYPE': 'Моля, изберете тип на намалението.',
				'REQUIRED_PROMOTION_TYPE': 'Моля, изберете тип на промоцията.',
				'REQUIRED_TICKET_NUMBER': 'Моля, въведете номер на билета.',
				'REQUIRED_COMMISSION': 'Моля, въведете комисионна.',
				'REQUIRED_CODE': 'Моля, въведете код.',
				'REQUIRED_EXCHANGE_RATE': 'Моля, въведете обеменен курс.',
				'TAKEN_SEAT': 'Това място не може да бъде избрано.',
				'CHOOSEN_SEAT': 'Това място вече е избрано.',
				'UNKNOWN_ERROR': 'Възникна грешка. Моля, опитайте отново.',
				'VALID_EMAIL': 'Моля, въведете верен имейл.',
				'VALID_ID': 'Моля, въведете валидно ЕГН.',
				'VALID_HOUR': 'Имате грешно въведени часове. Моля, въведете правилни часове във формат ччмм.',
				'VALID_SEATS': 'Местата не могат да бъдат по-малко от 1.',
				'VALID_SEATS_MAX': 'Местата не могат да бъдат повече от 120.',
				'VALID_PASSWORD_CONFIRM': 'Потвържденито на паролата не съвпада с паролата.',
				'VALID_EXCHANGE_RATE': 'Обменният курс не може да бъде по-малко от 1.',
				'NO_EMPTY_DATE_FIELDS': 'Полетата за дата са задължителни',
				'VALID_VALUE': 'Стойността не може да бъде по-малко от 1.',
				'ONLY_NUMBERS': 'Полето може да съдържа само цифри',
				'ONLY_STRINGS': 'Полето може да съдържа само латински букви',
				'NOT_AUTHORISED': 'Потребителят, който се оптвате да достъпите е невалиден',
				'UNABLE_TO_COPY_SEATS_DUE_TO_TAKEN_SEATS': 'Местата не могът да бъдат копирани, защото автобусът на тази дата съдържа заети места.',
				'SAME_STATION': 'На линията има вече спирка със същото име.',
				'NO_SELECTED_BUS': 'Моля изберете автобус',
				'NO_STATUS': 'Моля избере статус на билета (платен или резервиран)',
				'MULTIPLE_SUBLINES_SEAT_TITLE': 'Множество под линии',
				'MULTIPLE_SUBLINES_SEAT': 'За текущото място съществуват резервации с няколко под линии. За да редактирате мястото, първо трябва да изберете под линията.' 
			},
			'FIND_BUS_BY_DEPARTURE_DATE': 'Търсете автобуси по дата на заминаване',
			'FIRST_DRIVER': 'Първи шофьор',
			'FROM_TO': 'От-до',
			'FROM': 'От',
			'FROM_STATION': 'От спирка',
			'FROM_CITY': 'От град',
			'GOING': 'Отиване',
			'GOING_SEAT': 'Място на отиване:',
			'HEADING': {
				'CHANGE_PASSWORD': 'Смяна на парола',
				'CREATING_NEW_CITY': 'Създаване на нов град',
				'CREATING_NEW_LINE': 'Създаване на нова линия',
				'CREATING_NEW_STATION': 'Създаване на нова спирка',
				'CREATING_NEW_OFFICE': 'Създаване на нов офис',
				'CREATING_NEW_AGENT': 'Създаване на нов агент',
				'CREATING_NEW_DISCOUNT': 'Създаване на ново намаление',
				'CREATING_NEW_PROMOTION': 'Създаване на нова линия',
				'CREATING_NEW_ADMINISTRATOR': 'Създаване на нов администратор',
				'CREATING_NEW_CURRENCY': 'Създаване на нова валута',
				'EDITING_CITY': 'Редактиране на град',
				'EDITING_LINE': 'Редактиране на линия',
				'EDITING_STATION': 'Редактиране на спирка',
				'EDITING_OFFICE': 'Редактиране на офис',
				'EDITING_AGENT': 'Редактиране на агент',
				'EDITING_DISCOUNT': 'Редактиране на намаление',
				'EDITING_PROMOTION': 'Редактиране на промоция',
				'EDITING_TICKET': 'Редактиране на билет',
				'EDITING_ADMINISTRATOR': 'Редактиране на администратор',
				'EDITING_CURRENCY': 'Редактиране на валута',
				'PROMOTION_LINES': 'Промоционални линии',
				'SEATS_FROM_LINE': 'Заключване на места за линия',
				'EDITING_PROMOTION_LINES': 'Редактиране на промоционални линии',
				'PRINT_TICKET': 'Отпечатване на билет',
				'PRINT_REPORT': 'Отпечатване на отчет',
				'BUYING_TICKET': 'Закупуване на билет'
			},
			'ID_CLIENT_NUMBER': 'ЕГН / Клиентски номер',
			'CLINET_NUMBER': 'Клиентски номер',
			'ID_NUMBER': 'ЕГН',
			'I_WANT_TO': 'Искам да:',
			'MENU': 'Меню',
			'MARK_AS_REPORTED': 'Маркирай като отчетен',
			// For bg locale we have a lot of field with name for different languages,
			'NAME_OF': {
				'bg': 'Име',
				'en': 'Име на английски'
			},
			'NAME_OF_REVERSE': {
				'bg': 'Име на обратна линия',
				'en': 'Име на обратна линия на английски'
			},
			'NAME': 'Име',
			'NAMES': 'Имена',
			'NOT_FOUND': {
				'ADMINISTRATORS': 'Нямате намерени администратори.',
				'BUSES_BY_LINE': 'Нямате добавени автобуси към тази линия.',
				'BUSES_BY_DATE': 'Нямате добавени автобуси за тази дата.',
				'BUSES_ON_THAT_DATE': 'Няма намерени автобуси на отиване за тази дата.',
				'COUNTRY': 'Няма намерени държави.',
				'CITY': 'Няма намерени градове.',
				'CLIENT': 'Няма намерени клиенти.',
				'DISCOUNTS': 'Няма добавени намаления.',
				'POINT_IN_LINE': 'Няма добавени спирки към линията',
				'PRICE_IN_LINE': 'Няма добавени цени към линията',
				'STATION': 'Няма намерени спирки.',
				'RETURN_SUBLINES': 'Няма намерени линии навръщане по зададените критерии.',
				'GOING_SUBLINES': 'Няма намерени линии на отиване по зададените критерии.',
				'OFFICES': 'Няма намерени офиси.',
				'AGENTS': 'Няма намерени агенти.',
				'PROMOTIONS': 'Няма намерени промоции.',
				'SUB_LINES': 'Няма намерени под линии.',
				'PROMOTIONAL_LINES': 'Няма намерени промоционални линии.',
				'SOLD_TICKETS': 'Няма продадени билети за този автобус на тази дата.',
				'USERS': 'Няма намерени потребители'
			},
			'NOT_REPORTED': 'Неотчетен',
			'NOT_R': 'Н',
			'REP': 'O',
			'ANULATED': 'A',
			'NUMBER': 'Номер',
			'TRAVEL': 'Пътуващ',
			'NEW_PASSWORD': 'Нова парола',
			'NOTE': 'Забележка',
			'REVIEW_NOTE': {
				'INSPECTED': 'Забележка при отчитане',
				'CANCELED': 'Забележка при анулиране'
			},
			'LINE': 'Линия',
			'LOADING': 'Зареждане...',
			'ONE_WAY': 'Еднопосочен',
			'PAID': 'Платен',
			'PASSWORD': 'Парола',
			'PASSWORD_CONFIRM': 'Потвърждение на паролата',
			'PRICE': 'Цена',
			'PRICES_FOR_LINE': 'Цени за линия',
			'PERCENT': 'Процент',
			'PRICE_OF_TICKET': 'Цена на билет',
			'TICKET_NUMBER': 'Номер на билет',
			'PLEASE_CHOOSE_LINE': 'Моля, изберете линия:',
			'PHONE': 'Телефон',
			'PROMOTIONS_FROM_LINE': 'Промоции от линия',
			'REMOVE': 'Изтрий',
			'RESERVED': 'Резервиран',
			'RETURN': 'Връщане',
			'RETURN_SEAT': 'Място навръщане:',
			'SELECT_CITY': 'Избери град',
			'SELECTED_SUB_LINE': 'Избрани спирки',
			'SEATS': 'Места',
			'SEAT_NUMBER': 'Номер на място',
			'FREE_SEAT': 'Свободни места',
			'OCCUPIED_SEAT': 'Заето място',
			'PAID_SEAT': 'Платени места',
			'RESERVED–SEAT': 'Резервирано място',
			'CHOOSEN_SEAT': 'Избрано място',
			'LOCKED_SEAT': 'Заключено място',
			'SEARCHING': 'Търсене...',
			'SET_BUS_HOURS': 'Задай часове на автобуса:',
			'SET_BUS_SEATS': 'Задай брой места:',
			'SET_BUS_DAYS': 'Задай дни, в които пътува:',
			'SHOW_ALL_SUB_LINE': 'Покажи всички под линии',
			'SUCCESS': {
				'CREATE_BUS': 'Успешно създадохте нов автобус.',
				'CREATE_CITY': 'Успешно създадохте нов град.',
				'CREATE_STATION': 'Успешно създадохте нова спирка.',
				'CREATE_LINE': 'Успешно създадохте нова линия.',
				'CREATE_RESERVATION': 'Успешно създадохте нова резервация.',
				'CREATE_OFFICE': 'Успешно създадохте нов офис.',
				'CREATE_AGENT': 'Успешно създадохте нов агент.',
				'CREATE_DISCOUNT': 'Успешно създадохте ново намаление.',
				'CREATE_PROMOTION': 'Успешно създадохте нова промоция.',
				'CREATE_ADMINISTRATOR': 'Успешно създадохте нов администратор.',
				'CREATE_CURRENCY': 'Успешно създадохте нова валута.',
				'COPY_BUS': 'Успешно копирахте автобуса.',
				'COPY_LINE': 'Успешно копирахте линията.',
				'LINE_ADDED_TO_PROMOTION': 'Успешно добавихте нова линия към промоцията.',
				'LINE_REMOVED_TO_PROMOTION': 'Успешно премахнахте линия от промоцията.',
				'SUB_LINE_ADDED_TO_PROMOTION': 'Успешно добавихте нова под линия към промоцията.',
				'SUB_LINE_REMOVED_TO_PROMOTION': 'Успешно премахнахте под линия от промоцията.',
				'SAVE_LOCKED_SEATS': 'Успешно запазихте заключените места.',
				'COPY_LOCKED_SEATS': 'Успешно копирахте заключените места.',
				'UPDATE_BUS': 'Успешно променихте автобуса.',
				'UPDATE_CITY': 'Успешно променихте града.',
				'UPDATE_STATION': 'Успешно променихте спирката.',
				'UPDATE_LINE': 'Успешно променихте линията.',
				'UPDATE_OFFICE': 'Успешно променихте офиса.',
				'UPDATE_AGENT': 'Успешно променихте агент.',
				'UPDATE_PRICE': 'Успешно променихте цената.',
				'UPDATE_DISCOUNT': 'Успешно променихте намалението.',
				'UPDATE_PROMOTION': 'Успешно променихте промоцията.',
				'UPDATE_PASSWORD': 'Успешно променихте паролата.',
				'UPDATE_TICKET': 'Успешно променихте билета.',
				'UPDATE_ADMINISTRATOR': 'Успешно променихте администратора.',
				'UPDATE_CURRENCY': 'Успешно променихте валутата.',
				'DELETE_CITY': 'Успешно изтрихте града.',
				'DELETE_STATION': 'Успешно изтрихте спирката.',
				'DELETE_LINE': 'Успешно изтрихте линията.',
				'DELETE_BUS': 'Успешно изтрихте автобуса.',
				'DELETE_DISCOUNT': 'Успешно изтрихте намаление.',
				'DELETE_OFFICE': 'Успешно изтрихте офиса.',
				'DELETE_AGENT': 'Успешно изтрихте агента.',
				'DELETE_PRICE': 'Успешно изтрихте цена от линията.',
				'DELETE_PROMOTION': 'Успешно изтрихте промоцията.',
				'DELETE_ADMINISTRATOR': 'Успешно изтрихте администратора.',
				'DELETE_CURRENCY': 'Успешно изтрихте валутата.',
				'INSPECTED_TICKET': 'Успешно отчетохте билета.',
				'CANCELED_TICKET': 'Успешно анулирахте билета.'
			},
			'ONE-WAY': 'Еднопосочен',
			'ONE_PRICE_FOR_ALL_SUB_LINE': 'Една цена за всички под линии',
			'ON_FIRST_POSITION': 'Постави в началото',
			'ON_LAST_POSITION': 'Постави в края',
			'ON_PRESENT_POSITION': 'Запази сегашната позиция',
			'COUNTRY': 'Държава',
			'SELECT_FROM_EXIST_STATION': 'Избери спирка от линията',
			'SEE_EDIT_LOCKED_SEATS': 'Видя / променя заключените места',
			'SEAT': 'Място',
			'SECOND_DRIVER': 'Втори шофьор',
			'SIDEBAR': {
				'ADMINISTRATORS': 'Администратори',
				'AGENTS': 'Агенти',
				'BUSES': 'Автобуси',
				'CITIES': 'Градове',
				'DISCOUNTS': 'Намаления',
				'LOGOUT': 'Изход',
				'LINES': 'Линии',
				'OFFICES': 'Офиси',
				'TICKETS': 'Билети',
				'PRICES': 'Цени',
				'PROMOTIONS': 'Промоции',
				'RESERVATIONS': 'Резервации',
				'STATIONS': 'Спирки',
				'SALES': 'Продажби',
				'SEATS': 'Места',
				'REPORTS': 'Отчети',
				'LOCK_SEATS': 'Места',
				'WAYBILL': 'Пътен лист',
				'CURRENCIES': 'Валути',
				'NEGOTIATED': 'Договорени места'
			},
			'SHORT_HOUR': 'ч.',
			'SHOW_BUS_SCHEMA': 'Покажи схемата на автобуса',
			'SHOW_WAYBILL': 'Покажи пътния лист',
			'SWAP_CITIES': 'Обърни градовете',
			'STATION': 'Спирка',
			'SUB_LINES': 'Под линии',
			'SUB_LINE': 'Под линия',
			'SOLD_FROM': 'Продаден от',
			'TITLE': {
				'NEW_CITY': 'Нов град',
				'NEW_STATION': 'Нова спирка',
				'NEW_LINE': 'Нова линия',
				'NEW_OFFICE': 'Нов офис',
				'NEW_AGENT': 'Нов агент',
				'NEW_DISCOUNT': 'Ново намаление',
				'NEW_PROMOTION': 'Нова промоция',
				'NEW_ADMINISTRATOR': 'Нова администратор',
				'NEW_CURRENCY': 'Нова валута'
			},
			'TICKET': 'Билет',
			'TICKET_TYPE': 'Тип на билета:',
			'TICKET_STATUS': 'Статус на билета:',
			'THIRD_DRIVER': 'Трети шофьор',
			'TO': 'До',
			'TO_CITY': 'До град',
			'TO_STATION': 'До спирка',
			'TWO_WAY': 'Двупосочен',
			'VALUE': 'Стойност',
			'INSPECTED': 'Отчетен',
			'NOT_INSPECTED': 'Неотчетен',
			'VALID_FROM': 'Валидна от',
			'VALID_TO': 'Валидна до',
			'WEEK_DAYS': {
				'EVERYDAY': 'Всеки ден',
				'MONDAY': 'Понеделник',
				'TUESDAY': 'Вторник',
				'WEDNESDAY': 'Сряда',
				'THURSDAY': 'Четвъртък',
				'FRIDAY': 'Петък',
				'SATURDAY': 'Събота',
				'SUNDAY': 'Неделя'
			},
			'REPORTED': 'Отчетен',
			'REPORTS': {
				'PAYMENT_SYSTEM': 'Покажи отчетите направени през системата на ePay и EasyPay',
				'MY_REPORTS': 'Покажи моите отчети',
				'TICKET_FILTER': 'Покажи филтър по номер на билет',
				'TICKET': 'Билет',
				'SEAT': 'Място',
				'RETURN_SEAT': 'Място на връщане',
				'TYPE': 'Тип',
				'NAME': 'Име',
				'EGN': 'ЕГН',
				'PRICE': 'Цена',
				'DISCOUNT': 'Намаление',
				'FROM': 'От',
				'TO': 'До',
				'AGENT_NAME': 'Име агент',
				'TOTAL': 'Общо: ',
				'REPORT_PRICE': 'Отчетна цена',
				'USER_SEARCH': 'Търси потребител',
				'ONE_WAY': 'Е',
				'TWO_WAY': 'Д',
				'USER': 'Потребител',
				'NUMBER_SEARCH': 'Търсене по номер на билет',
				'DATE_SEARCH': 'Търсене по дата',
				'NUMBER_FROM_SEARCH': 'Въведете номер на билет от, който да започне търсенето.',
				'NUMBER_TO_SEARCH': 'Въведете номер на билет до, който да търсите.',
				'SHOW_UNCONFIRMED_ONLY': 'Покажи само неотчетените билети'
			},
			'REGISTRATION_NUMBER': 'Регистрационен номер',
			'SALES': {
				'ROUTE': 'Маршрут',
				'DEPARTURE': 'Тръгване',
				'HOUR': 'Час',
				'DATE_OF_ISSUE': 'Дата на издаване',
				'SHOW_TICKET': 'Покажи билет'
			},
			'WITHOUT_DISCOUNT': 'Без намаление',
			'PUBLIC': {
				'BUS_SEARCH': 'Търсене на билет',
				'BUS_STOPS': 'Автобусна линия: ',
				'NO_RESULT': 'Няма намерени автобуси на отиване за тази дата.',
				'NO_RETURN_RESULT': 'Няма намерени автобуси на връщане за тази дата.',
				'TIME_HINT': 'Всички часове са в местно време',
				'TRAVEL_TO': 'Пътува до',
				'WElCOME_TEXT': {
					'HOW': 'Как',
					'WORKS': 'Работи'
				},
				'SWAP': 'Размени',
				'TITLE': {
					'HOME': 'Към началната страница'
				},
				'STEP': 'Стъпка',
				'STEP_ONE_TEXT': 'До къде пътувате',
				'STEP_1': 'До къде пътувате',
				'STEP_DESCRIPTION_1': 'Изберете от къде, до къде пътувате и дата на пътуването Ви.',
				'STEP_TWO_TEXT': 'Изберете най-добрият маршрут',
				'STEP_2': 'Резервирайте предпочитано място',
				'STEP_DESCRIPTION_2': 'Изберете предпочитано от Вас място и направете резервцията си.',
				'STEP_THREE_TEXT': 'Купете бързо и безопасно',
				'STEP_3': 'Купете бързо и безопасно',
				'STEP_DESCRIPTION_3': 'Купете бързо и безопасно вашият билет, чрез системата на Epay.',			
				'CHOOSE_SEAT_FROM_SCHEMA': '(Изберете място от схемата)',
				'WElCOME_TO': 'Добре дошли в',
				'BOTTOM_MENU': {
					'ABOUT_US': 'За нас',
					'HOW_TO': 'Как да резервирам',
					'PAYMENT': 'Плащане',
					'TERMS_AND_CONDITIONS': 'Общи условия',
					'RECOMENDATIONS': 'Мнения и препоръки',
					'CONTACTS': 'Контакти',
					'OFFICES': 'Офиси',
					'TERMS': 'Условия за ползване',
					'PRIVACY': 'Политика за поверителност',
					'COOKIE_POLICY': 'Политика на бисквитките'
				},
				'LOGIN_TO_BTMS': 'Вход в системата',
				'RETURN_TICKET': 'Билет на връщане',
				'ONE_WAY_TICKET': 'Билет на отиване',
				'SHOW_TICKET': 'Преглед на билет',
				'EPAY_PAYMENT': 'Плащане чрез:',
				'PASSANGER_NAME': 'Име на пътник',
				'THANK_YOU': 'Благодарим Ви!',
				'SUCCESS_MESSAGE': 'Вие успешно запазихте билет за нашите автобусни линии.',
				'BON_VOAYAGE': 'Приятно пътуване!',
				'AGENTS_ENTRANCE': 'Вход за агенти',
				'PAYMENT': 'Плащане'
			},
			'SET_BASE_CURRENCY': 'Основната валута, която използвате е :',
			'TEXT_OVER_CHOOSE_BUTTON': 'Избери автобуси и продължи, за да получиш отстъпка за двупосочен билет.',
			'NEW': {
				'WELCOME': 'Добре дошли в " ГРУП " ООД и "МОДИ ТРАНС" ООД',
				'TRANSPORT': 'Пътнически превози до:',
				'SOFIA': 'София',
				'BUDAPEST': 'Будапеща',
				'BRATISLAVA': 'Братислава',
				'BRNO': 'Бърно',
				'PRAGUE': 'Прага',
				'BUY_IN_THREE_STEPS': 'Купете своя билет само в три стъпки:',
				'DISCOUNT': 'При покупка на билет от www.group-ood.com Вие получавате следните отстъпки:'
			},
			'LINK': 'Линк',
			'USER_LINK': 'Потребителски линк',
			'USER_LINK_COPY': 'За да копирате натиснете Ctr+C'
		})
		.translations('en', {
			'HELLO': 'Hello, ',
			'CUSTOM_SOFTWARE_DEVELOPMENT_WOLLOW': 'Custom Software Development by Wollow Soft',
			'ADD_NEW_CITY': 'Add new city',
			'ADD': 'Add',
			'AMOUNT': 'Amount',
			'ADDRESS': 'Address',
			'AFTER_POINT': 'Put after...',
			'ALL_RIGHTS_RESERVED': 'All rights reserved',
			'AVAILABLE_LINES': 'Available lines',
			'ARRIVES': 'Arrival',
			'BASE_CURRENCY': 'Base currency',
			'BUSES_FROM_LINE': 'Buses fom line',
			'BUS': 'Bus',
			'BUS_SCHEMA_WARNING': 'The seats of the scheme can not corespond to the actual location of the bus seats. Group LTD. reserves the right to change the number of the place from the reservation.',
			'BUS_SCHEMA': 'Bus schema',
			'BUSES_GOING_OTHER_DAYS': 'Busses going in other days:',
			'BUSES_RETURN_OTHER_DAYS': 'Busses return in other days:',
			'CURRENCIES': {
				'BGN': 'BGN',
				'EUR': '€'
			},
			'CANCELED': 'Canceled',
			'CITY': 'City',
			'COPY': 'Copy',
			'CODE': 'Code',
			'COMMISSION': 'Commission',
			'ACCOUNTING_PRICE': 'Accounting price',
			'COPY_LOCKED_SEATS': 'Copy locked seats for another date',
			'COMPLETED_ROUTES': 'Completed routes:',
			'CURRENT_PASSWORD': 'Current password',
			'CHOOSE': 'Choose',
			'CHOOSE_LINE': 'Choose line',
			'CHOOSE_GOING_BUS': 'Choose going bus:',
			'CHOOSE_RETURN_BUS': 'Choose return bus:',
			'CHOOSE_STATIONS_TO_CHANGE_SEATS': 'Please select bus stops to edit the seats of bus',
			'CHOOSE_BUS_AND_DATE_TO_PICK_STATIONS': 'Please select bus and date to be able to select stations',
			'CLIENT_DATA': 'Client data:',
			'CLEAR_FIELDS': 'Clear fields',
			'CREATED_BY': 'Created by',
			'CREATE_REVERSE_LINE': 'Create reverse line',
			'CONFIRM': {
				'EDIT_SEAT': 'Selected seat is occupied. Do you want to edit?',
				'DELETE': 'Are you sure you want to delete this entry?',
				'LOCKED_SEATS_NOT_SAVED': 'You have changes that did not keep. Are you sure you want to continue?',
				'OVERWRITE_LOCKED_SEATS': 'The bus that date has already locked locations. Do you want to overwrite?',
				'CANCEL_TICKET': 'Are you sure you want to cancel this ticket?',
				'CHANGE_STATIONS_LINE': 'Changing the stops along the line will result in the loss of bus prices, reports and tickets to this line. Are you sure you want to continue?'
			},
			'DATE': 'Date',
			'DATE_DEPARTURE': 'Departure date',
			'DATE_RETURNS': 'Return date',
			'DATE_FROM': 'Starting date',
			'FROM_DATE': 'From date',
			'DATE_TO': 'End date',
			'DATE_FOR_COPY': 'Date copy',
			'TO_DATE': 'To date',
			'DAYS': 'Days',
			'STATISTICS': 'Display statistics for period',
			'NO_DATA': 'No results found',
			'SEARCH_TICKET': 'Tърсете билет',
			'SEARCH_LINE': 'Search line',
			'DESCRIPTION': 'Description',
			'DESCRIPTION_OF': {
				'bg': 'Description',
				'en': 'Description in english'
			},
			'DEPARTURE': 'Departure',
			'DEPARTURE_IN': 'Departure in',
			'ARRIVES_AT': 'Arrives at',
			'DEPARTURE_FROM': 'Departs from',
			'DELETE_CONFIRM': 'Are you sure you want to delete this entry?',
			'DIRECTION': 'Direction',
			'DISCOUNT': 'Discount',
			'EMAIL': 'E-mail',
			'EMAIL_USERNAME': 'E-mail/Username',
			'EXCHANGE_RATE': 'Exchange rate',
			'RATIO': 'Ratio',
			'EDIT': 'Edit',
			'EDIT_LINES': 'Edit lines',
			'ERRORS': {
				'GENERAL': 'Please enter the correct data.',
				'MINLENGTH_PASSWORD': 'The password should be at least 6 characters.',
				'MINLENGTH_PASSWORD_CONFIRM': 'Confirmation password must be at least 6 characters.',
				'MINLENGTH_NAME': 'The name should be not less than 4 characters.',
				'MINLENGTH_LINE_NAME': 'The name must be at least 3 characters.',
				'MINLENGTH_DESCRIPTION': 'The description must be at least 3 characters.',
				'MINVALUE_PRICE': 'The minimum value of the ticket is to be not less than 0.01',
				'MINVALUE_COMMISSION': 'The minimum commission should be not less than 0.00',
				'MAXVALUE_PRICE': 'The maximum value of the ticket must be not more than 10000',
				'MAXLENGTH_PASSWORD': 'The password must be no more than 30 characters.',
				'MAXLENGTH_PASSWORD_CONFIRM': 'Confirmation password must be no more than 30 characters.',
				'MAXLENGTH_NAME': 'The name must be no more than 30 characters.',
				'MAXLENGTH_LINE_NAME': 'The name must be no more than 40 characters.',
				'MAXLENGTH_DESCRIPTION': 'The description should be no longer than 100 characters.',
				'MAXVALUE_COMMISSION': 'The maximum value of the commission must be no more than 100%.',
				'REQUIRED_ARRIVES_HOUR': 'Please enter arrival in town',
				'REQUIRED_ADDRESS': 'Please enter your address.',
				'REQUIRED_CITY': 'Please select city.',
				'REQUIRED_COUNTRY': 'Please select a country.',
				'REQUIRED_CONFIRM_PASSWORD': 'Please confirm your password.',
				'REQUIRED_DATE': 'Please select a date.',
				'REQUIRED_DAYS': 'Please select days.',
				'REQUIRED_DEPARTURE_HOUR': 'Моля, въведете час на заминаване от град',
				'REQUIRED_DESCRIPTION': 'Please enter a description.',
				'REQUIRED_EMAIL': 'Please enter your email.',
				'REQUIRED_DATA': 'Please enter correct data.',
				'REQUIRED_VALID_EMAIL': 'Please enter a valid email.',
				'REQUIRED_VALID_DATA': 'Please enter a valid data.',
				'REQUIRED_VALID_PHONE': 'Please enter valid phone number!',
				'REQUIRED_EXISTING_STATION': 'Please select one of the existing stations.',
				'REQUIRED_GOING_LINE': 'Please select the line going.',
				'REQUIRED_GOING_SEAT': 'Please select the going seat.',
				'REQUIRED_RETURN_SEAT': 'Please select a return seat.',
				'REQUIRED_ID': 'Please enter personal ID nuber.',
				'REQUIRED_NAME': 'Please enter a name.',
				'REQUIRED_RETURN_DATA': 'Please enter data for return.',
				'REQUIRED_RETURN_LINE': 'Please select line return.',
				'REQUIRED_NAMES': 'Please enter names.',
				'REQUIRED_PASSWORD': 'Please enter a password.',
				'REQUIRED_PASSWORD_CONFIRM': 'Please enter password verification.',
				'REQUIRED_PHONE': 'Please enter your phone.',
				'REQUIRED_PRICE': 'Please enter the ticket price',
				'REQUIRED_SEATS': 'Please enter places.',
				'REQUIRED_STATION': 'Please enter stop.',
				'REQUIRED_STATIONS': 'Please enter more than one bus stop.',
				'REQUIRED_STATUS': 'Please select the ticket status.',
				'REQUIRED_TICKET_TYPE': 'Please select the type of ticket.',
				'REQUIRED_TELEPHONE': 'Please enter a phone number',
				'REQUIRED_VALUE': 'Please enter a value.',
				'REQUIRED_DISCOUNT_TYPE': 'Please select the type of reduction.',
				'REQUIRED_PROMOTION_TYPE': 'Please select the type of promotion.',
				'REQUIRED_TICKET_NUMBER': 'Please enter the ticket number.',
				'REQUIRED_COMMISSION': 'Please enter commission.',
				'REQUIRED_CODE': 'Please enter code.',
				'REQUIRED_EXCHANGE_RATE': 'Please enter exchange rate.',
				'TAKEN_SEAT': 'This place can not be selected.',
				'CHOOSEN_SEAT': 'This place is already selected.',
				'UNKNOWN_ERROR': 'There was an error. Please, try again.',
				'VALID_EMAIL': 'Please enter a correct email.',
				'VALID_ID': 'Please enter a valid personal ID.',
				'VALID_HOUR': 'You have entered the wrong times. Please enter the correct time in the format hhmm.',
				'VALID_SEATS': 'The seats can not be less than 1.',
				'VALID_PASSWORD_CONFIRM': 'Confirmation of password does not match password.',
				'VALID_EXCHANGE_RATE': 'The exchange rate can not be less than 1.',
				'NO_EMPTY_DATE_FIELDS': 'Date fields are required',
				'VALID_VALUE': 'The value can not be less than 1.',
				'ONLY_NUMBERS': 'The field can contain only numbers',
				'ONLY_STRINGS': 'The field may contain only latin letters',
				'NOT_AUTHORISED': 'The user you are trying to access is invalid',
				'UNABLE_TO_COPY_SEATS_DUE_TO_TAKEN_SEATS': 'Seats may not be copied, because the bus on that date contained busy places.',
				'SAME_STATION': 'Line already has a bus station of the same name.',
				'NO_SELECTED_BUS': 'Please select bus',
				'MULTIPLE_SUBLINES_SEAT_TITLE': 'Multiple sub lines',
				'MULTIPLE_SUBLINES_SEAT': 'There are multiple sub lines reservation for the current seat. If you want ot edit this seat, you have to select the sub line first.'
			},
			'FIND_BUS_BY_DEPARTURE_DATE': 'Search buses by date of departure',
			'FIRST_DRIVER': 'First driver',
			'FROM_TO': 'From-To',
			'FROM': 'From',
			'FROM_STATION': 'From station',
			'FROM_CITY': 'From city',
			'GOING': 'Going',
			'GOING_SEAT': 'Seat on departure:',
			'HEADING': {
				'CHANGE_PASSWORD': 'Change password',
				'CREATING_NEW_CITY': 'Creating a new city',
				'CREATING_NEW_LINE': 'Creating a new line',
				'CREATING_NEW_STATION': 'СCreating a new bus station',
				'CREATING_NEW_OFFICE': 'Creating a new office',
				'CREATING_NEW_AGENT': 'Creating a new agent',
				'CREATING_NEW_DISCOUNT': 'Creating a new discount',
				'CREATING_NEW_PROMOTION': 'Creating a new promotion',
				'CREATING_NEW_ADMINISTRATOR': 'Creating a new administrator',
				'CREATING_NEW_CURRENCY': 'Creating a new currency',
				'EDITING_CITY': 'Edit city',
				'EDITING_LINE': 'Edit line',
				'EDITING_STATION': 'Edit station',
				'EDITING_OFFICE': 'Edit office',
				'EDITING_AGENT': 'Edit agent',
				'EDITING_DISCOUNT': 'Edit discount',
				'EDITING_PROMOTION': 'Edit promotion',
				'EDITING_TICKET': 'Edit ticket',
				'EDITING_ADMINISTRATOR': 'Edit administrator',
				'EDITING_CURRENCY': 'Edit currency',
				'PROMOTION_LINES': 'Promotional lines',
				'SEATS_FROM_LINE': 'Lock seats fom line',
				'EDITING_PROMOTION_LINES': 'Edit promotional lines',
				'PRINT_TICKET': 'Print ticket',
				'PRINT_REPORT': 'Print report',
				'BUYING_TICKET': 'Purchasing a ticket'
			},
			'ID_CLIENT_NUMBER': 'ID / client number',
			'CLINET_NUMBER': 'Client number',
			'ID_NUMBER': 'PIN',
			'I_WANT_TO': 'I want to:',
			'MENU': 'Menu',
			'MARK_AS_REPORTED': 'Mark as reported',
			// For bg locale we have a lot of field with name for different languages,
			'NAME_OF': {
				'bg': 'Name',
				'en': 'Name in english'
			},
			'NAME_OF_REVERSE': {
				'bg': 'Name of return line',
				'en': 'Name of return line in english'
			},
			'NAME': 'Name',
			'NAMES': 'Names',
			'NOT_FOUND': {
				'ADMINISTRATORS': 'There are no administrators.',
				'BUSES_BY_LINE': 'You have not added buses on this line.',
				'BUSES_BY_DATE': 'You have not added buses that date.',
				'BUSES_ON_THAT_DATE': 'There are no buses going to that date.',
				'COUNTRY': 'There are no countries.',
				'CITY': 'There are no cities.',
				'CLIENT': 'There are no clients.',
				'DISCOUNTS': 'There are no discounts.',
				'POINT_IN_LINE': 'There are no stops to the line',
				'PRICE_IN_LINE': 'There are no prices to the line',
				'STATION': 'There are no stops.',
				'RETURN_SUBLINES': 'There are no lines comeback search criteria.',
				'GOING_SUBLINES': 'There are no lines going search criteria.',
				'OFFICES': 'There are no offices.',
				'AGENTS': 'There are no agents.',
				'PROMOTIONS': 'There are no promotions.',
				'SUB_LINES': 'There are no sub lines.',
				'PROMOTIONAL_LINES': 'There are no promotional lines.',
				'SOLD_TICKETS': 'No tickets sold for this bus to this date.',
				'USERS': 'There no users found'
			},
			'NOT_REPORTED': 'Not reported',
			'NUMBER': 'Number',
			'TRAVEL': 'Itinerant',
			'NEW_PASSWORD': 'New pasword',
			'NOTE': 'Note',
			'REVIEW_NOTE': {
				'INSPECTED': 'Note taking into account',
				'CANCELED': 'Note cancellation'
			},
			'LINE': 'Line',
			'LOADING': 'Loading...',
			'ONE_WAY': 'One way',
			'PAID': 'Paid',
			'PASSWORD': 'Password',
			'PASSWORD_CONFIRM': 'Password confirm',
			'PRICE': 'Price',
			'PRICES_FOR_LINE': 'Line prices',
			'PERCENT': 'Percent',
			'PRICE_OF_TICKET': 'Ticket price',
			'TICKET_NUMBER': 'Ticket number',
			'PLEASE_CHOOSE_LINE': 'Please choose line:',
			'PHONE': 'Phone',
			'PROMOTIONS_FROM_LINE': 'Promotions from line',
			'REMOVE': 'Remove',
			'RESERVED': 'reserved',
			'RETURN': 'Return',
			'RETURN_SEAT': 'Seat on return:',
			'SELECT_CITY': 'Select city',
			'SELECTED_SUB_LINE': 'Choosen bus stops',
			'SEATS': 'Seats',
			'SEAT_NUMBER': 'Seat number',
			'FREE_SEAT': 'Free seats',
			'OCCUPIED_SEAT': 'Occupied seats',
			'PAID_SEAT': 'Paid seats',
			'RESERVED–SEAT': 'Reserved seat',
			'CHOOSEN_SEAT': 'Choosen seat',
			'LOCKED_SEAT': 'Locked seat',
			'SEARCHING': 'Searching...',
			'SET_BUS_HOURS': 'Set bus hours:',
			'SET_BUS_SEATS': 'Set bus seats:',
			'SET_BUS_DAYS': 'Set days when traveling:',
			'SHOW_ALL_SUB_LINE': 'Show all sub lines',
			'BTN': {
				'ADD': 'Add',
				'ADD_NEW_BUS': 'Add bus',
				'ADD_CITY_BTN': 'Add city',
				'ADD_NEW_DISCOUNT': 'Add discount',
				'ADD_NEW_CITY': 'Add new city',
				'ADD_NEW_LINE': 'Add new line',
				'ADD_NEW_STATION': 'Add new station',
				'ADD_NEW_OFFICE': 'Add new office',
				'ADD_NEW_AGENT': 'Add new agent',
				'ADD_NEW_PROMOTION': 'Add new promotion',
				'ADD_NEW_ADMINISTRATOR': 'Add new administrator',
				'ADD_NEW_CURRENCY': 'Add new currency',
				'ADD_STATION': 'Add station',
				'ADD_LINES': 'Add lines',
				'BACK': 'Back',
				'BACK_TO_LAST_PAGE': 'Back to last page',
				'CANCEL': 'Cancel',
				'CANCEL_ALIAS': 'Discard',
				'CHANGE_DATA_GOING': 'Change return data',
				'CHANGE_DATA_RETURN': 'Change going data',
				'CHANGE_PASSWORD': 'Change password',
				'CHANGE_BUS': 'Change bus',
				'LOGIN': 'Login',
				'NEW_CLIENT': 'New client',
				'SAVE': 'Save',
				'SAVE_CHANGES': 'Save changes',
				'SAVE_LINE': 'Save line',
				'SEARCH': 'Search',
				'EDIT': 'Edit',
				'REMOVE': 'Remove',
				'RESERVE': 'Reserve',
				'PRINT': 'Print',
				'PREVIEW': 'Preview',
				'BUY': 'BUY',
				'EDIT_SEAT': 'Edit seat',
				'CONTINUE': 'Continue',
				'DELETE_RESERVATION': 'Delete reservation',
				'CLOSE': 'Close'				
			},
			'SUCCESS': {
				'CREATE_BUS': 'Successfully created a new bus.',
				'CREATE_CITY': 'Successfully created a new city.',
				'CREATE_STATION': 'Successfully created a new bus stop.',
				'CREATE_LINE': 'Successfully created a new line.',
				'CREATE_RESERVATION': 'Successfully created a new reservation.',
				'CREATE_OFFICE': 'Successfully created a new office.',
				'CREATE_AGENT': 'Successfully created a new agent.',
				'CREATE_DISCOUNT': 'Successfully created a new discount.',
				'CREATE_PROMOTION': 'Successfully created a new promotion.',
				'CREATE_ADMINISTRATOR': 'Successfully created a new administrator.',
				'CREATE_CURRENCY': 'Successfully created a new currency.',
				'COPY_BUS': 'Successfully copied bus.',
				'COPY_LINE': 'Successfully copied line.',
				'LINE_ADDED_TO_PROMOTION': 'Successfully added a new line to promotion.',
				'LINE_REMOVED_TO_PROMOTION': 'Successfully removed a line of promotion.',
				'SUB_LINE_ADDED_TO_PROMOTION': 'Successfully added a new sub line to promotion.',
				'SUB_LINE_REMOVED_TO_PROMOTION': 'Successfully removed below the line promotion.',
				'SAVE_LOCKED_SEATS': 'Successfully saved the locked seats.',
				'COPY_LOCKED_SEATS': 'Successfully copied locked seats.',
				'UPDATE_BUS': 'Successfully changed bus.',
				'UPDATE_CITY': 'Successfully changed city.',
				'UPDATE_STATION': 'Successfully changed the station.',
				'UPDATE_LINE': 'Successfully changed line.',
				'UPDATE_OFFICE': 'Successfully changed the office.',
				'UPDATE_AGENT': 'Successfully changed agent.',
				'UPDATE_PRICE': 'Successfully changed the price.',
				'UPDATE_DISCOUNT': 'Successfully changed reduction.',
				'UPDATE_PROMOTION': 'Successfully changed promotion.',
				'UPDATE_PASSWORD': 'Successfully changed password.',
				'UPDATE_TICKET': 'Successfully changed the ticket.',
				'UPDATE_ADMINISTRATOR': 'Successfully changed administrator.',
				'UPDATE_CURRENCY': 'Successfully changed currency.',
				'DELETE_CITY': 'Successfully deleted town.',
				'DELETE_STATION': 'Successfully deleted station.',
				'DELETE_LINE': 'Successfully deleted the line.',
				'DELETE_BUS': 'Successfully deleted bus.',
				'DELETE_DISCOUNT': 'Successfully deleted reduction.',
				'DELETE_OFFICE': 'Successfully deleted office.',
				'DELETE_AGENT': 'Successfully deleted agent.',
				'DELETE_PRICE': 'Successfully deleted cost of the line.',
				'DELETE_PROMOTION': 'Successfully deleted promotion.',
				'DELETE_ADMINISTRATOR': 'Successfully deleted administrator.',
				'DELETE_CURRENCY': 'Successfully deleted currency.',
				'INSPECTED_TICKET': 'Successfully recorded a ticket.',
				'CANCELED_TICKET': 'Successfully canceled tickets.'
			},
			'ONE-WAY': 'Oneway',
			'ONE_PRICE_FOR_ALL_SUB_LINE': 'One price for all sub lines',
			'ON_FIRST_POSITION': 'Paste at the beginning',
			'ON_LAST_POSITION': 'Paste at the end',
			'ON_PRESENT_POSITION': 'Keep current position',
			'COUNTRY': 'Country',
			'SELECT_FROM_EXIST_STATION': 'Choose bus stop fom line',
			'SEE_EDIT_LOCKED_SEATS': 'Look at / change locked seats',
			'SEAT': 'Seat',
			'SECOND_DRIVER': 'Second driver',
			'SIDEBAR': {
				'ADMINISTRATORS': 'Administrators',
				'AGENTS': 'Agents',
				'BUSES': 'Buses',
				'CITIES': 'Cities',
				'DISCOUNTS': 'Discounts',
				'LOGOUT': 'Logout',
				'LINES': 'Lines',
				'OFFICES': 'Offices',
				'TICKETS': 'Tickets',
				'PRICES': 'Proces',
				'PROMOTIONS': 'Promotions',
				'RESERVATIONS': 'Reservations',
				'STATIONS': 'Bus stops',
				'SALES': 'Sales',
				'SEATS': 'Seats',
				'REPORTS': 'Reports',
				'LOCK_SEATS': 'Seats',
				'WAYBILL': 'Waybill',
				'CURRENCIES': 'Currencies',
				'NEGOTIATED': 'Negotiated seats'
			},
			'SHORT_HOUR': 'h.',
			'SHOW_BUS_SCHEMA': 'Show bus schema',
			'SHOW_WAYBILL': 'Show waybill',
			'SWAP_CITIES': 'Swap cities',
			'STATION': 'Station',
			'SUB_LINES': 'Sub lines',
			'SUB_LINE': 'Sub line',
			'SOLD_FROM': 'Sold from',
			'TITLE': {
				'NEW_CITY': 'New city',
				'NEW_STATION': 'New station',
				'NEW_LINE': 'New line',
				'NEW_OFFICE': 'New office',
				'NEW_AGENT': 'New agent',
				'NEW_DISCOUNT': 'New discount',
				'NEW_PROMOTION': 'New promotion',
				'NEW_ADMINISTRATOR': 'New administrator',
				'NEW_CURRENCY': 'New currency'
			},
			'TICKET': 'Ticket',
			'TICKET_TYPE': 'Ticket type:',
			'TICKET_STATUS': 'Ticket status:',
			'THIRD_DRIVER': 'Third driver',
			'TO': 'To',
			'TO_CITY': 'To city',
			'TO_STATION': 'To station',
			'TWO_WAY': 'Two way',
			'VALUE': 'Value',
			'INSPECTED': 'inspected',
			'NOT_INSPECTED': 'Uninspected',
			'VALID_FROM': 'Valid from',
			'VALID_TO': 'Valid to',
			'WEEK_DAYS': {
				'EVERYDAY': 'Every day',
				'MONDAY': 'Monday',
				'TUESDAY': 'Tuesday',
				'WEDNESDAY': 'Wednesday',
				'THURSDAY': 'Thursday',
				'FRIDAY': 'Friday',
				'SATURDAY': 'Saturday',
				'SUNDAY': 'Sunday'
			},
			'REPORTED': 'Reported',
			'REPORTS': {
				'PAYMENT_SYSTEM': 'Show reports made trough the system of ePay and EasyPay',
				'MY_REPORTS': 'Show my reports',
				'TICKET_FILTER': 'Show filter by ticket number',
				'TICKET': 'Ticket',
				'SEAT': 'Seat',
				'RETURN_SEAT': 'Return seat',
				'TYPE': 'Type',
				'NAME': 'Name',
				'EGN': 'PIN',
				'PRICE': 'Price',
				'DISCOUNT': 'Discount',
				'FROM': 'From',
				'TO': 'To',
				'AGENT_NAME': 'Agent name',
				'TOTAL': 'Total: ',
				'REPORT_PRICE': 'Report price',
				'USER_SEARCH': 'Search user',
				'ONE_WAY': 'O',
				'TWO_WAY': 'T',
				'USER': 'User',
				'NUMBER_SEARCH': 'Search by ticket number',
				'DATE_SEARCH': 'Search by date',
				'NUMBER_FROM_SEARCH': 'Please enter start ticket number.',
				'NUMBER_TO_SEARCH': 'Please enter end ticket number.',
				'SHOW_UNCONFIRMED_ONLY': 'Show only unconfirmed tickets.'
			},
			'REGISTRATION_NUMBER': 'Registration number',
			'SALES': {
				'ROUTE': 'Route',
				'DEPARTURE': 'Departure',
				'HOUR': 'Hour',
				'DATE_OF_ISSUE': 'DAte of issue',
				'SHOW_TICKET': 'Show ticket'
			},
			'WITHOUT_DISCOUNT': 'Without discount',
			'PUBLIC': {
				'BUS_SEARCH': 'Search for ticket',
				'BUS_STOPS': 'Bus line: ',
				'NO_RESULT': 'There are no buses going to that date.',
				'NO_RETURN_RESULT': 'There are no buses to return on that date.',
				'TIME_HINT': 'All times are local',
				'TRAVEL_TO': 'Travels to',
				'WElCOME_TEXT': {
					'HOW': 'How',
					'WORKS': 'it works'
				},
				'SWAP': 'swap',
				'TITLE': {
					'HOME': 'Go to homepage'
				},
				'STEP': 'Step',
				'STEP_ONE_TEXT': 'Where to travel',
				'STEP_1': 'Where to travel',
				'STEP_DESCRIPTION_1': 'Choose where to travel from where and date of your trip.',
				'STEP_TWO_TEXT': 'Choose best seat',
				'STEP_2': 'Choose best seat',
				'STEP_DESCRIPTION_2': 'Select your preferred location and make your reservation.',
				'STEP_THREE_TEXT': 'Buy fast and safety',
				'STEP_3': 'Buy fast and safety',
				'STEP_DESCRIPTION_3': 'Purchase quickly and safely your ticket through a system of ePay.',
				'CHOOSE_SEAT_FROM_SCHEMA': '(Choose seat from the bus schema)',
				'WElCOME_TO': 'Welcome to',
				'BOTTOM_MENU': {
					'ABOUT_US': 'About us',
					'HOW_TO': 'How to',
					'PAYMENT': 'Payment',
					'TERMS_AND_CONDITIONS': 'Terms and conditions',
					'RECOMENDATIONS': 'Recomendations',
					'CONTACTS': 'Contacts',
					'OFFICES': 'Offices',
					'TERMS': 'Terms of use',
					'PRIVACY': 'Privacy policy',
					'COOKIE_POLICY': 'Cookie policy'
				},
				'LOGIN_TO_BTMS': 'Login to system',
				'RETURN_TICKET': 'Return ticket',
				'ONE_WAY_TICKET': 'Ticket going',
				'SHOW_TICKET': 'Show ticket',
				'EPAY_PAYMENT': 'ePay payment:',
				'PASSANGER_NAME': 'Passanger name',
				'THANK_YOU': 'Thank you!',
				'SUCCESS_MESSAGE': 'You have successfully saved ticket for our bus lines.',
				'BON_VOAYAGE': 'Pleasant trip!',
				'AGENTS_ENTRANCE': 'Agents login',
				'PAYMENT': 'Payment'
			},
			'SET_BASE_CURRENCY': 'Current base currency is set to: ',
			'NEW': {
				'WELCOME': 'Welcome to " GROUP " ООД and "MODI TRANS"',
				'TRANSPORT': 'Passenger transport to:',
				'SOFIA': 'Sofia',
				'BUDAPEST': 'Budapest',
				'BRATISLAVA': 'Bratislava',
				'BRNO': 'Brno',
				'PRAGUE': 'Prague',
				'BUY_IN_THREE_STEPS': 'Buy your ticket in just three steps:',
				'DISCOUNT': 'When buying a ticket from www.group-ood.com you get the following discounts:'				
			},
			'LINK': 'Link',
			'USER_LINK': 'User link',
			'USER_LINK_COPY': 'Copy to clipboard: Press Ctr+C'
		})
		.translations('cz', {
			'HELLO': 'Hello, ',
			'CUSTOM_SOFTWARE_DEVELOPMENT_WOLLOW': 'Custom Software Development by Wollow Soft',
			'ADD_NEW_CITY': 'Add new city',
			'ADD': 'Add',
			'AMOUNT': 'Amount',
			'ADDRESS': 'Address',
			'AFTER_POINT': 'Put after...',
			'ALL_RIGHTS_RESERVED': 'All rights reserved',
			'AVAILABLE_LINES': 'Available lines',
			'ARRIVES': 'Příchod',
			'BASE_CURRENCY': 'Base currency',
			'BUSES_FROM_LINE': 'Buses fom line',
			'BUS': 'Bus',
			'BUS_SCHEMA_WARNING': 'Sedadla tohoto režimu nemohou corespond ke skutečnému umístění autobusových míst. Group Ltd . si vyhrazuje právo na změnu čísla míst od rezervace .',
			'BUS_SCHEMA': 'Bus schema',
			'BUSES_GOING_OTHER_DAYS': 'Busses going in other days:',
			'BUSES_RETURN_OTHER_DAYS': 'Busses return in other days:',
			'CURRENCIES': {
				'BGN': 'BGN',
				'EUR': '€'
			},
			'CANCELED': 'Canceled',
			'CITY': 'City',
			'COPY': 'Copy',
			'CODE': 'Code',
			'COMMISSION': 'Commission',
			'ACCOUNTING_PRICE': 'Accounting price',
			'COPY_LOCKED_SEATS': 'Copy locked seats for another date',
			'COMPLETED_ROUTES': 'Completed routes:',
			'CURRENT_PASSWORD': 'Current password',
			'CHOOSE': 'Choose',
			'CHOOSE_LINE': 'Choose line',
			'CHOOSE_GOING_BUS': 'Vyberte si bude autobus:',
			'CHOOSE_RETURN_BUS': 'Zvolit zpáteční autobus:',
			'CHOOSE_STATIONS_TO_CHANGE_SEATS': 'Please select bus stops to edit the seats of bus',
			'CHOOSE_BUS_AND_DATE_TO_PICK_STATIONS': 'Please select bus and date to be able to select stations',
			'CLIENT_DATA': 'Client data:',
			'CLEAR_FIELDS': 'Clear fields',
			'CREATED_BY': 'Created by',
			'CREATE_REVERSE_LINE': 'Create reverse line',
			'CONFIRM': {
				'EDIT_SEAT': 'Selected seat is occupied. Do you want to edit?',
				'DELETE': 'Are you sure you want to delete this entry?',
				'LOCKED_SEATS_NOT_SAVED': 'You have changes that did not keep. Are you sure you want to continue?',
				'OVERWRITE_LOCKED_SEATS': 'The bus that date has already locked locations. Do you want to overwrite?',
				'CANCEL_TICKET': 'Are you sure you want to cancel this ticket?',
				'CHANGE_STATIONS_LINE': 'Changing the stops along the line will result in the loss of bus prices, reports and tickets to this line. Are you sure you want to continue?'
			},
			'DATE': 'Date',
			'DATE_DEPARTURE': 'Datum odletu',
			'DATE_RETURNS': 'Datum návratu',
			'DATE_FROM': 'Starting date',
			'FROM_DATE': 'From date',
			'DATE_TO': 'End date',
			'DATE_FOR_COPY': 'Date copy',
			'TO_DATE': 'To date',
			'DAYS': 'Days',
			'STATISTICS': 'Display statistics for period',
			'NO_DATA': 'No results found',
			'SEARCH_TICKET': 'Tърсете билет',
			'SEARCH_LINE': 'Search line',
			'DESCRIPTION': 'Description',
			'DESCRIPTION_OF': {
				'bg': 'Description',
				'en': 'Description in english'
			},
			'DEPARTURE': 'Odchod',
			'DEPARTURE_IN': 'Odjezd v',
			'ARRIVES_AT': 'Arrives at',
			'DEPARTURE_FROM': 'Odchýlí od',
			'DELETE_CONFIRM': 'Are you sure you want to delete this entry?',
			'DIRECTION': 'Direction',
			'DISCOUNT': 'Sleva',
			'EMAIL': 'E-mail',
			'EMAIL_USERNAME': 'E-mail/Username',
			'EXCHANGE_RATE': 'Exchange rate',
			'RATIO': 'Ratio',
			'EDIT': 'Edit',
			'EDIT_LINES': 'Edit lines',
			'ERRORS': {
				'PAYMENT_SYSTEM': 'Show reports made trough the system of ePay and EasyPay',
				'GENERAL': 'Please enter the correct data.',
				'MINLENGTH_PASSWORD': 'The password should be at least 6 characters.',
				'MINLENGTH_PASSWORD_CONFIRM': 'Confirmation password must be at least 6 characters.',
				'MINLENGTH_NAME': 'The name should be not less than 4 characters.',
				'MINLENGTH_LINE_NAME': 'The name must be at least 3 characters.',
				'MINLENGTH_DESCRIPTION': 'The description must be at least 3 characters.',
				'MINVALUE_PRICE': 'The minimum value of the ticket is to be not less than 0.01',
				'MINVALUE_COMMISSION': 'The minimum commission should be not less than 0.00',
				'MAXVALUE_PRICE': 'The maximum value of the ticket must be not more than 10000',
				'MAXLENGTH_PASSWORD': 'The password must be no more than 30 characters.',
				'MAXLENGTH_PASSWORD_CONFIRM': 'Confirmation password must be no more than 30 characters.',
				'MAXLENGTH_NAME': 'The name must be no more than 30 characters.',
				'MAXLENGTH_LINE_NAME': 'The name must be no more than 40 characters.',
				'MAXLENGTH_DESCRIPTION': 'The description should be no longer than 100 characters.',
				'MAXVALUE_COMMISSION': 'The maximum value of the commission must be no more than 100%.',
				'REQUIRED_ARRIVES_HOUR': 'Please enter arrival in town',
				'REQUIRED_ADDRESS': 'Please enter your address.',
				'REQUIRED_CITY': 'Prosím, vyberte město .',
				'REQUIRED_COUNTRY': 'Please select a country.',
				'REQUIRED_CONFIRM_PASSWORD': 'Please confirm your password.',
				'REQUIRED_DATE': 'Prosím, vyberte datum .',
				'REQUIRED_DAYS': 'Please select days.',
				'REQUIRED_DEPARTURE_HOUR': 'Моля, въведете час на заминаване от град',
				'REQUIRED_DESCRIPTION': 'Please enter a description.',
				'REQUIRED_EMAIL': 'Please enter your email.',
				'REQUIRED_DATA': 'Please enter correct data.',
				'REQUIRED_VALID_EMAIL': 'Please enter a valid email.',
				'REQUIRED_VALID_DATA': 'Please enter a valid data.',
				'REQUIRED_VALID_PHONE': 'Please enter valid phone number!',
				'REQUIRED_EXISTING_STATION': 'Please select one of the existing stations.',
				'REQUIRED_GOING_LINE': 'Please select the line going.',
				'REQUIRED_GOING_SEAT': 'Please select the going seat.',
				'REQUIRED_RETURN_SEAT': 'Please select a return seat.',
				'REQUIRED_ID': 'Please enter personal ID nuber.',
				'REQUIRED_NAME': 'Please enter a name.',
				'REQUIRED_RETURN_DATA': 'Please enter data for return.',
				'REQUIRED_RETURN_LINE': 'Please select line return.',
				'REQUIRED_NAMES': 'Please enter names.',
				'REQUIRED_PASSWORD': 'Please enter a password.',
				'REQUIRED_PASSWORD_CONFIRM': 'Please enter password verification.',
				'REQUIRED_PHONE': 'Please enter your phone.',
				'REQUIRED_PRICE': 'Please enter the ticket price',
				'REQUIRED_SEATS': 'Please enter places.',
				'REQUIRED_STATION': 'Please enter stop.',
				'REQUIRED_STATIONS': 'Please enter more than one bus stop.',
				'REQUIRED_STATUS': 'Please select the ticket status.',
				'REQUIRED_TICKET_TYPE': 'Please select the type of ticket.',
				'REQUIRED_TELEPHONE': 'Please enter a phone number',
				'REQUIRED_VALUE': 'Please enter a value.',
				'REQUIRED_DISCOUNT_TYPE': 'Please select the type of reduction.',
				'REQUIRED_PROMOTION_TYPE': 'Please select the type of promotion.',
				'REQUIRED_TICKET_NUMBER': 'Please enter the ticket number.',
				'REQUIRED_COMMISSION': 'Please enter commission.',
				'REQUIRED_CODE': 'Please enter code.',
				'REQUIRED_EXCHANGE_RATE': 'Please enter exchange rate.',
				'TAKEN_SEAT': 'This place can not be selected.',
				'CHOOSEN_SEAT': 'This place is already selected.',
				'UNKNOWN_ERROR': 'There was an error. Please, try again.',
				'VALID_EMAIL': 'Please enter a correct email.',
				'VALID_ID': 'Please enter a valid personal ID.',
				'VALID_HOUR': 'You have entered the wrong times. Please enter the correct time in the format hhmm.',
				'VALID_SEATS': 'The seats can not be less than 1.',
				'VALID_PASSWORD_CONFIRM': 'Confirmation of password does not match password.',
				'VALID_EXCHANGE_RATE': 'The exchange rate can not be less than 1.',
				'NO_EMPTY_DATE_FIELDS': 'Date fields are required',
				'VALID_VALUE': 'The value can not be less than 1.',
				'ONLY_NUMBERS': 'The field can contain only numbers',
				'ONLY_STRINGS': 'The field may contain only latin letters',
				'NOT_AUTHORISED': 'The user you are trying to access is invalid',
				'UNABLE_TO_COPY_SEATS_DUE_TO_TAKEN_SEATS': 'Seats may not be copied, because the bus on that date contained busy places.',
				'SAME_STATION': 'Line already has a bus station of the same name.',
				'NO_SELECTED_BUS': 'Please select bus',
				'MULTIPLE_SUBLINES_SEAT_TITLE': 'Multiple sub lines',
				'MULTIPLE_SUBLINES_SEAT': 'There are multiple sub lines reservation for the current seat. If you want ot edit this seat, you have to select the sub line first.'
			},
			'FIND_BUS_BY_DEPARTURE_DATE': 'Search buses by date of departure',
			'FIRST_DRIVER': 'First driver',
			'FROM_TO': 'From-To',
			'FROM': 'Od',
			'FROM_STATION': 'From station',
			'FROM_CITY': 'From city',
			'GOING': 'Going',
			'GOING_SEAT': 'Seat při odjezdu:',
			'HEADING': {
				'CHANGE_PASSWORD': 'Change password',
				'CREATING_NEW_CITY': 'Creating a new city',
				'CREATING_NEW_LINE': 'Creating a new line',
				'CREATING_NEW_STATION': 'СCreating a new bus station',
				'CREATING_NEW_OFFICE': 'Creating a new office',
				'CREATING_NEW_AGENT': 'Creating a new agent',
				'CREATING_NEW_DISCOUNT': 'Creating a new discount',
				'CREATING_NEW_PROMOTION': 'Creating a new promotion',
				'CREATING_NEW_ADMINISTRATOR': 'Creating a new administrator',
				'CREATING_NEW_CURRENCY': 'Creating a new currency',
				'EDITING_CITY': 'Edit city',
				'EDITING_LINE': 'Edit line',
				'EDITING_STATION': 'Edit station',
				'EDITING_OFFICE': 'Edit office',
				'EDITING_AGENT': 'Edit agent',
				'EDITING_DISCOUNT': 'Edit discount',
				'EDITING_PROMOTION': 'Edit promotion',
				'EDITING_TICKET': 'Edit ticket',
				'EDITING_ADMINISTRATOR': 'Edit administrator',
				'EDITING_CURRENCY': 'Edit currency',
				'PROMOTION_LINES': 'Promotional lines',
				'SEATS_FROM_LINE': 'Lock seats fom line',
				'EDITING_PROMOTION_LINES': 'Edit promotional lines',
				'PRINT_TICKET': 'Print ticket',
				'PRINT_REPORT': 'Print report',
				'BUYING_TICKET': 'Purchasing a ticket'
			},
			'ID_CLIENT_NUMBER': 'ID / client number',
			'CLINET_NUMBER': 'Client number',
			'ID_NUMBER': 'PIN',
			'I_WANT_TO': 'I want to:',
			'MENU': 'Menu',
			'MARK_AS_REPORTED': 'Mark as reported',
			// For bg locale we have a lot of field with name for different languages,
			'NAME_OF': {
				'bg': 'Name',
				'en': 'Name in english'
			},
			'NAME_OF_REVERSE': {
				'bg': 'Name of return line',
				'en': 'Name of return line in english'
			},
			'NAME': 'Jméno',
			'NAMES': 'Names',
			'NOT_FOUND': {
				'ADMINISTRATORS': 'There are no administrators.',
				'BUSES_BY_LINE': 'You have not added buses on this line.',
				'BUSES_BY_DATE': 'You have not added buses that date.',
				'BUSES_ON_THAT_DATE': 'There are no buses going to that date.',
				'COUNTRY': 'There are no countries.',
				'CITY': 'Neexistují žádné města .',
				'CLIENT': 'There are no clients.',
				'DISCOUNTS': 'There are no discounts.',
				'POINT_IN_LINE': 'There are no stops to the line',
				'PRICE_IN_LINE': 'There are no prices to the line',
				'STATION': 'There are no stops.',
				'RETURN_SUBLINES': 'There are no lines comeback search criteria.',
				'GOING_SUBLINES': 'There are no lines going search criteria.',
				'OFFICES': 'There are no offices.',
				'AGENTS': 'There are no agents.',
				'PROMOTIONS': 'There are no promotions.',
				'SUB_LINES': 'There are no sub lines.',
				'PROMOTIONAL_LINES': 'There are no promotional lines.',
				'SOLD_TICKETS': 'No tickets sold for this bus to this date.'
			},
			'NOT_REPORTED': 'Not reported',
			'NUMBER': 'Number',
			'NEW_PASSWORD': 'New pasword',
			'NOTE': 'Note',
			'REVIEW_NOTE': {
				'INSPECTED': 'Note taking into account',
				'CANCELED': 'Note cancellation'
			},
			'LINE': 'Line',
			'LOADING': 'Loading...',
			'ONE_WAY': 'Jednosměrný',
			'PAID': 'Paid',
			'PASSWORD': 'Password',
			'PASSWORD_CONFIRM': 'Password confirm',
			'PRICE': 'Cena',
			'PRICES_FOR_LINE': 'Line prices',
			'PERCENT': 'Percent',
			'PRICE_OF_TICKET': 'Ticket price',
			'TICKET_NUMBER': 'Ticket number',
			'PLEASE_CHOOSE_LINE': 'Please choose line:',
			'PHONE': 'Telefon',
			'PROMOTIONS_FROM_LINE': 'Promotions from line',
			'REMOVE': 'Remove',
			'RESERVED': 'reserved',
			'RETURN': 'Return',
			'RETURN_SEAT': 'Seat on return:',
			'SELECT_CITY': 'Select city',
			'SELECTED_SUB_LINE': 'Choosen bus stops',
			'SEATS': 'Seats',
			'SEAT_NUMBER': 'číslo sedadla',
			'FREE_SEAT': 'Volná místa',
			'OCCUPIED_SEAT': 'obsazené sedačky',
			'PAID_SEAT': 'Paid seats',
			'RESERVED–SEAT': 'Reserved seat',
			'CHOOSEN_SEAT': 'vybrali sedadla',
			'LOCKED_SEAT': 'Locked seat',
			'SEARCHING': 'Searching...',
			'SET_BUS_HOURS': 'Set bus hours:',
			'SET_BUS_SEATS': 'Set bus seats:',
			'SET_BUS_DAYS': 'Set days when traveling:',
			'SHOW_ALL_SUB_LINE': 'Show all sub lines',
			'BTN': {
				'ADD': 'Add',
				'ADD_NEW_BUS': 'Add bus',
				'ADD_CITY_BTN': 'Add city',
				'ADD_NEW_DISCOUNT': 'Add discount',
				'ADD_NEW_CITY': 'Add new city',
				'ADD_NEW_LINE': 'Add new line',
				'ADD_NEW_STATION': 'Add new station',
				'ADD_NEW_OFFICE': 'Add new office',
				'ADD_NEW_AGENT': 'Add new agent',
				'ADD_NEW_PROMOTION': 'Add new promotion',
				'ADD_NEW_ADMINISTRATOR': 'Add new administrator',
				'ADD_NEW_CURRENCY': 'Add new currency',
				'ADD_STATION': 'Add station',
				'ADD_LINES': 'Add lines',
				'BACK': 'Back',
				'BACK_TO_LAST_PAGE': 'Back to last page',
				'CANCEL': 'Cancel',
				'CANCEL_ALIAS': 'Discard',
				'CHANGE_DATA_GOING': 'Change return data',
				'CHANGE_DATA_RETURN': 'Change going data',
				'CHANGE_PASSWORD': 'Change password',
				'CHANGE_BUS': 'Change bus',
				'LOGIN': 'Login',
				'NEW_CLIENT': 'New client',
				'SAVE': 'Save',
				'SAVE_CHANGES': 'Save changes',
				'SAVE_LINE': 'Save line',
				'SEARCH': 'Vyhledávání',
				'EDIT': 'Edit',
				'REMOVE': 'Remove',
				'RESERVE': 'Rezervovat',
				'PRINT': 'Print',
				'PREVIEW': 'Preview',
				'BUY': 'BUY',
				'EDIT_SEAT': 'Edit seat',
				'CONTINUE': 'Pokračovat',
				'DELETE_RESERVATION': 'Delete reservation',
				'CLOSE': 'Close'				
			},
			'SUCCESS': {
				'CREATE_BUS': 'Successfully created a new bus.',
				'CREATE_CITY': 'Successfully created a new city.',
				'CREATE_STATION': 'Successfully created a new bus stop.',
				'CREATE_LINE': 'Successfully created a new line.',
				'CREATE_RESERVATION': 'Successfully created a new reservation.',
				'CREATE_OFFICE': 'Successfully created a new office.',
				'CREATE_AGENT': 'Successfully created a new agent.',
				'CREATE_DISCOUNT': 'Successfully created a new discount.',
				'CREATE_PROMOTION': 'Successfully created a new promotion.',
				'CREATE_ADMINISTRATOR': 'Successfully created a new administrator.',
				'CREATE_CURRENCY': 'Successfully created a new currency.',
				'COPY_BUS': 'Successfully copied bus.',
				'COPY_LINE': 'Successfully copied line.',
				'LINE_ADDED_TO_PROMOTION': 'Successfully added a new line to promotion.',
				'LINE_REMOVED_TO_PROMOTION': 'Successfully removed a line of promotion.',
				'SUB_LINE_ADDED_TO_PROMOTION': 'Successfully added a new sub line to promotion.',
				'SUB_LINE_REMOVED_TO_PROMOTION': 'Successfully removed below the line promotion.',
				'SAVE_LOCKED_SEATS': 'Successfully saved the locked seats.',
				'COPY_LOCKED_SEATS': 'Successfully copied locked seats.',
				'UPDATE_BUS': 'Successfully changed bus.',
				'UPDATE_CITY': 'Successfully changed city.',
				'UPDATE_STATION': 'Successfully changed the station.',
				'UPDATE_LINE': 'Successfully changed line.',
				'UPDATE_OFFICE': 'Successfully changed the office.',
				'UPDATE_AGENT': 'Successfully changed agent.',
				'UPDATE_PRICE': 'Successfully changed the price.',
				'UPDATE_DISCOUNT': 'Successfully changed reduction.',
				'UPDATE_PROMOTION': 'Successfully changed promotion.',
				'UPDATE_PASSWORD': 'Successfully changed password.',
				'UPDATE_TICKET': 'Successfully changed the ticket.',
				'UPDATE_ADMINISTRATOR': 'Successfully changed administrator.',
				'UPDATE_CURRENCY': 'Successfully changed currency.',
				'DELETE_CITY': 'Successfully deleted town.',
				'DELETE_STATION': 'Successfully deleted station.',
				'DELETE_LINE': 'Successfully deleted the line.',
				'DELETE_BUS': 'Successfully deleted bus.',
				'DELETE_DISCOUNT': 'Successfully deleted reduction.',
				'DELETE_OFFICE': 'Successfully deleted office.',
				'DELETE_AGENT': 'Successfully deleted agent.',
				'DELETE_PRICE': 'Successfully deleted cost of the line.',
				'DELETE_PROMOTION': 'Successfully deleted promotion.',
				'DELETE_ADMINISTRATOR': 'Successfully deleted administrator.',
				'DELETE_CURRENCY': 'Successfully deleted currency.',
				'INSPECTED_TICKET': 'Successfully recorded a ticket.',
				'CANCELED_TICKET': 'Successfully canceled tickets.'
			},
			'ONE-WAY': 'Oneway',
			'ONE_PRICE_FOR_ALL_SUB_LINE': 'One price for all sub lines',
			'ON_FIRST_POSITION': 'Paste at the beginning',
			'ON_LAST_POSITION': 'Paste at the end',
			'ON_PRESENT_POSITION': 'Keep current position',
			'COUNTRY': 'Country',
			'SELECT_FROM_EXIST_STATION': 'Choose bus stop fom line',
			'SEE_EDIT_LOCKED_SEATS': 'Look at / change locked seats',
			'SEAT': 'Sedadlo',
			'SECOND_DRIVER': 'Second driver',
			'SIDEBAR': {
				'ADMINISTRATORS': 'Administrators',
				'AGENTS': 'Agents',
				'BUSES': 'Buses',
				'CITIES': 'Cities',
				'DISCOUNTS': 'Discounts',
				'LOGOUT': 'Logout',
				'LINES': 'Lines',
				'OFFICES': 'Offices',
				'TICKETS': 'Tickets',
				'PRICES': 'Proces',
				'PROMOTIONS': 'Promotions',
				'RESERVATIONS': 'Reservations',
				'STATIONS': 'Bus stops',
				'SALES': 'Sales',
				'SEATS': 'Seats',
				'REPORTS': 'Reports',
				'LOCK_SEATS': 'Seats',
				'WAYBILL': 'Waybill',
				'CURRENCIES': 'Currencies',
				'NEGOTIATED': 'Negotiated seats'
			},
			'SHORT_HOUR': 'h.',
			'SHOW_BUS_SCHEMA': 'Show bus schema',
			'SHOW_WAYBILL': 'Show waybill',
			'SWAP_CITIES': 'Swap cities',
			'STATION': 'Station',
			'SUB_LINES': 'Sub lines',
			'SUB_LINE': 'Sub line',
			'SOLD_FROM': 'Sold from',
			'TITLE': {
				'NEW_CITY': 'New city',
				'NEW_STATION': 'New station',
				'NEW_LINE': 'New line',
				'NEW_OFFICE': 'New office',
				'NEW_AGENT': 'New agent',
				'NEW_DISCOUNT': 'New discount',
				'NEW_PROMOTION': 'New promotion',
				'NEW_ADMINISTRATOR': 'New administrator',
				'NEW_CURRENCY': 'New currency'
			},
			'TICKET': 'Ticket',
			'TICKET_TYPE': 'Ticket type:',
			'TICKET_STATUS': 'Ticket status:',
			'THIRD_DRIVER': 'Third driver',
			'TO': 'Na',
			'TO_CITY': 'To city',
			'TO_STATION': 'To station',
			'TWO_WAY': 'Dvoucestný',
			'VALUE': 'Value',
			'INSPECTED': 'inspected',
			'NOT_INSPECTED': 'Uninspected',
			'VALID_FROM': 'Valid from',
			'VALID_TO': 'Valid to',
			'WEEK_DAYS': {
				'EVERYDAY': 'Every day',
				'MONDAY': 'Monday',
				'TUESDAY': 'Tuesday',
				'WEDNESDAY': 'Wednesday',
				'THURSDAY': 'Thursday',
				'FRIDAY': 'Friday',
				'SATURDAY': 'Saturday',
				'SUNDAY': 'Sunday'
			},
			'REPORTED': 'Reported',
			'REPORTS': {
				'PAYMENT_SYSTEM': 'Show reports made trough the system of ePay and EasyPay',
				'MY_REPORTS': 'Show my reports',
				'TICKET': 'Ticket',
				'SEAT': 'Seat',
				'RETURN_SEAT': 'Return seat',
				'TYPE': 'Type',
				'NAME': 'Jméno',
				'EGN': 'PIN',
				'PRICE': 'Price',
				'DISCOUNT': 'Sleva',
				'FROM': 'From',
				'TO': 'To',
				'AGENT_NAME': 'Agent name',
				'TOTAL': 'Total: ',
				'REPORT_PRICE': 'Report price',
				'USER_SEARCH': 'Search user',
				'ONE_WAY': 'O',
				'TWO_WAY': 'T',
				'USER': 'User'
			},
			'REGISTRATION_NUMBER': 'REgistration number',
			'SALES': {
				'ROUTE': 'Route',
				'DEPARTURE': 'Departure',
				'HOUR': 'Hour',
				'DATE_OF_ISSUE': 'DAte of issue',
				'SHOW_TICKET': 'Show ticket'
			},
			'WITHOUT_DISCOUNT': 'bez slevy',
			'PUBLIC': {
				'BUS_SEARCH': 'Vyhledávání letenku',
				'BUS_STOPS': 'Autobusová linka: ',
				'NO_RESULT': 'There are no buses going to that date.',
				'NO_RETURN_RESULT': 'Nejsou žádné autobusy, které jezdí po tomto datu .',
				'TIME_HINT': 'Všechny časy jsou místní',
				'TRAVEL_TO': 'Cestuje do',
				'WElCOME_TEXT': {
					'HOW': 'Jak',
					'WORKS': 'funguje to'
				},
				'SWAP': 'výměna',
				'TITLE': {
					'HOME': 'Jít na domovskou stránku'
				},
				'STEP': 'Krok',
				'STEP_ONE_TEXT': 'Kde cestovat',
				'STEP_1': 'Kde cestovat',
				'STEP_DESCRIPTION_1': 'Vyberte, kam cestovat a datum vaší cesty.',
				'STEP_TWO_TEXT': 'Zvolit nejlepší způsob',
				'STEP_2': 'Zvolit nejlepší způsob',
				'STEP_DESCRIPTION_2': 'Vyberte nejvýhodnější polohu a aby vaše rezervtsiyata.',
				'STEP_THREE_TEXT': 'Prodám rychle a bezpečnost',
				'STEP_3': 'Prodám rychle a bezpečnost',
				'STEP_DESCRIPTION_3': 'Kupte si rychle a bezpečně si letenku prostřednictvím systému ePay .',
				'CHOOSE_SEAT_FROM_SCHEMA': '(Vyberte si sedadlo od autobusového schématu)',
				'WElCOME_TO': 'Vítejte na stránkách',
				'BOTTOM_MENU': {
					'TERMS': 'Terms of use',
					'PRIVACY': 'Privacy policy',
					'COOKIE_POLICY': 'Cookie policy'
				},
				'LOGIN_TO_BTMS': 'Přihlášení do systému',
				'RETURN_TICKET': 'Zpáteční lístek',
				'ONE_WAY_TICKET': 'Vstupenka bude',
				'SHOW_TICKET': 'Show vstupenka',
				'EPAY_PAYMENT': 'platba ePay:',
				'PASSANGER_NAME': 'Jméno cestujícího',
				'THANK_YOU': 'Děkuji!',
				'SUCCESS_MESSAGE': 'Úspěšně jste uložili letenku pro naše autobusových linek .',
				'BON_VOAYAGE': 'Šťastnou cestu !',
				'AGENTS_ENTRANCE': 'Agenti přihlášení',
				'PAYMENT': 'Platba'
			},
			'SET_BASE_CURRENCY': 'Current base currency is set to: ',
			'NEGOTIATED': {
				'LABEL': 'Negotiated seats'
			},
			'NEW': {
				'WELCOME': 'Vítejte na " GROUP " LTD a " MODI TRANS " LTD',
				'TRANSPORT': 'Přeprava cestujících na:',
				'SOFIA': 'Sofia',
				'BUDAPEST': 'Budapest',
				'BRATISLAVA': 'Bratislava',
				'BRNO': 'Brno',
				'PRAGUE': 'Prague',
				'BUY_IN_THREE_STEPS': 'Koupit si lístek v pouhých třech krocích :',
				'DISCOUNT': 'Při koupi jízdenky z www.group-ood.com získáte následující slevy:'								
			},
			'LINK': 'Link',
			'USER_LINK': 'User link',
			'USER_LINK_COPY': 'Copy to clipboard: Press Ctr+C'
		})
		.translations('hu', {
			'HELLO': 'Hello, ',
			'CUSTOM_SOFTWARE_DEVELOPMENT_WOLLOW': 'Custom Software Development by Wollow Soft',
			'ADD_NEW_CITY': 'Add new city',
			'ADD': 'Add',
			'AMOUNT': 'Amount',
			'ADDRESS': 'Address',
			'AFTER_POINT': 'Put after...',
			'ALL_RIGHTS_RESERVED': 'All rights reserved',
			'AVAILABLE_LINES': 'Available lines',
			'ARRIVES': 'Érkezés',
			'BASE_CURRENCY': 'Base currency',
			'BUSES_FROM_LINE': 'Buses fom line',
			'BUS': 'Bus',
			'BUS_SCHEMA_WARNING': 'Az ülések a rendszer nem corespond a tényleges helyét a buszon helyet. Group Kft . fenntartja magának a jogot, hogy a szám a hely a foglalás.',
			'BUS_SCHEMA': 'Bus schema',
			'BUSES_GOING_OTHER_DAYS': 'Busses going in other days:',
			'BUSES_RETURN_OTHER_DAYS': 'Busses return in other days:',
			'CURRENCIES': {
				'BGN': 'BGN',
				'EUR': '€'
			},
			'CANCELED': 'Canceled',
			'CITY': 'City',
			'COPY': 'Copy',
			'CODE': 'Code',
			'COMMISSION': 'Commission',
			'ACCOUNTING_PRICE': 'Accounting price',
			'COPY_LOCKED_SEATS': 'Copy locked seats for another date',
			'COMPLETED_ROUTES': 'Completed routes:',
			'CURRENT_PASSWORD': 'Current password',
			'CHOOSE': 'Choose',
			'CHOOSE_LINE': 'Choose line',
			'CHOOSE_GOING_BUS': 'Válasszon megy busz:',
			'CHOOSE_RETURN_BUS': 'Válasszon visszatérő busz:',
			'CHOOSE_STATIONS_TO_CHANGE_SEATS': 'Please select bus stops to edit the seats of bus',
			'CHOOSE_BUS_AND_DATE_TO_PICK_STATIONS': 'Please select bus and date to be able to select stations',
			'CLIENT_DATA': 'Client data:',
			'CLEAR_FIELDS': 'Clear fields',
			'CREATED_BY': 'Created by',
			'CREATE_REVERSE_LINE': 'Create reverse line',
			'CONFIRM': {
				'EDIT_SEAT': 'Selected seat is occupied. Do you want to edit?',
				'DELETE': 'Are you sure you want to delete this entry?',
				'LOCKED_SEATS_NOT_SAVED': 'You have changes that did not keep. Are you sure you want to continue?',
				'OVERWRITE_LOCKED_SEATS': 'The bus that date has already locked locations. Do you want to overwrite?',
				'CANCEL_TICKET': 'Are you sure you want to cancel this ticket?',
				'CHANGE_STATIONS_LINE': 'Changing the stops along the line will result in the loss of bus prices, reports and tickets to this line. Are you sure you want to continue?'
			},
			'DATE': 'Date',
			'DATE_DEPARTURE': 'Indulási időpont',
			'DATE_RETURNS': 'Visszatérítési dátum',
			'DATE_FROM': 'Starting date',
			'FROM_DATE': 'From date',
			'DATE_TO': 'End date',
			'DATE_FOR_COPY': 'Date copy',
			'TO_DATE': 'To date',
			'DAYS': 'Days',
			'STATISTICS': 'Display statistics for period',
			'NO_DATA': 'No results found',
			'SEARCH_TICKET': 'Tърсете билет',
			'SEARCH_LINE': 'Search line',
			'DESCRIPTION': 'Description',
			'DESCRIPTION_OF': {
				'bg': 'Description',
				'en': 'Description in english'
			},
			'DEPARTURE': 'Indulás',
			'DEPARTURE_IN': 'Indító',
			'ARRIVES_AT': 'Arrives at',
			'DEPARTURE_FROM': 'Eltér',
			'DELETE_CONFIRM': 'Are you sure you want to delete this entry?',
			'DIRECTION': 'Direction',
			'DISCOUNT': 'Kedvezmény',
			'EMAIL': 'Email',
			'EMAIL_USERNAME': 'E-mail/Username',
			'EXCHANGE_RATE': 'Exchange rate',
			'RATIO': 'Ratio',
			'EDIT': 'Edit',
			'EDIT_LINES': 'Edit lines',
			'ERRORS': {
				'GENERAL': 'Please enter the correct data.',
				'MINLENGTH_PASSWORD': 'The password should be at least 6 characters.',
				'MINLENGTH_PASSWORD_CONFIRM': 'Confirmation password must be at least 6 characters.',
				'MINLENGTH_NAME': 'The name should be not less than 4 characters.',
				'MINLENGTH_LINE_NAME': 'The name must be at least 3 characters.',
				'MINLENGTH_DESCRIPTION': 'The description must be at least 3 characters.',
				'MINVALUE_PRICE': 'The minimum value of the ticket is to be not less than 0.01',
				'MINVALUE_COMMISSION': 'The minimum commission should be not less than 0.00',
				'MAXVALUE_PRICE': 'The maximum value of the ticket must be not more than 10000',
				'MAXLENGTH_PASSWORD': 'The password must be no more than 30 characters.',
				'MAXLENGTH_PASSWORD_CONFIRM': 'Confirmation password must be no more than 30 characters.',
				'MAXLENGTH_NAME': 'The name must be no more than 30 characters.',
				'MAXLENGTH_LINE_NAME': 'The name must be no more than 40 characters.',
				'MAXLENGTH_DESCRIPTION': 'The description should be no longer than 100 characters.',
				'MAXVALUE_COMMISSION': 'The maximum value of the commission must be no more than 100%.',
				'REQUIRED_ARRIVES_HOUR': 'Please enter arrival in town',
				'REQUIRED_ADDRESS': 'Please enter your address.',
				'REQUIRED_CITY': 'Kérem válasszon várost.',
				'REQUIRED_COUNTRY': 'Please select a country.',
				'REQUIRED_CONFIRM_PASSWORD': 'Please confirm your password.',
				'REQUIRED_DATE': 'Kérjük, válasszon ki egy dátumot .',
				'REQUIRED_DAYS': 'Please select days.',
				'REQUIRED_DEPARTURE_HOUR': 'Моля, въведете час на заминаване от град',
				'REQUIRED_DESCRIPTION': 'Please enter a description.',
				'REQUIRED_EMAIL': 'Please enter your email.',
				'REQUIRED_DATA': 'Please enter correct data.',
				'REQUIRED_VALID_EMAIL': 'Please enter a valid email.',
				'REQUIRED_VALID_DATA': 'Please enter a valid data.',
				'REQUIRED_VALID_PHONE': 'Please enter valid phone number!',
				'REQUIRED_EXISTING_STATION': 'Please select one of the existing stations.',
				'REQUIRED_GOING_LINE': 'Please select the line going.',
				'REQUIRED_GOING_SEAT': 'Please select the going seat.',
				'REQUIRED_RETURN_SEAT': 'Please select a return seat.',
				'REQUIRED_ID': 'Please enter personal ID nuber.',
				'REQUIRED_NAME': 'Please enter a name.',
				'REQUIRED_RETURN_DATA': 'Please enter data for return.',
				'REQUIRED_RETURN_LINE': 'Please select line return.',
				'REQUIRED_NAMES': 'Please enter names.',
				'REQUIRED_PASSWORD': 'Please enter a password.',
				'REQUIRED_PASSWORD_CONFIRM': 'Please enter password verification.',
				'REQUIRED_PHONE': 'Please enter your phone.',
				'REQUIRED_PRICE': 'Please enter the ticket price',
				'REQUIRED_SEATS': 'Please enter places.',
				'REQUIRED_STATION': 'Please enter stop.',
				'REQUIRED_STATIONS': 'Please enter more than one bus stop.',
				'REQUIRED_STATUS': 'Please select the ticket status.',
				'REQUIRED_TICKET_TYPE': 'Please select the type of ticket.',
				'REQUIRED_TELEPHONE': 'Please enter a phone number',
				'REQUIRED_VALUE': 'Please enter a value.',
				'REQUIRED_DISCOUNT_TYPE': 'Please select the type of reduction.',
				'REQUIRED_PROMOTION_TYPE': 'Please select the type of promotion.',
				'REQUIRED_TICKET_NUMBER': 'Please enter the ticket number.',
				'REQUIRED_COMMISSION': 'Please enter commission.',
				'REQUIRED_CODE': 'Please enter code.',
				'REQUIRED_EXCHANGE_RATE': 'Please enter exchange rate.',
				'TAKEN_SEAT': 'This place can not be selected.',
				'CHOOSEN_SEAT': 'This place is already selected.',
				'UNKNOWN_ERROR': 'There was an error. Please, try again.',
				'VALID_EMAIL': 'Please enter a correct email.',
				'VALID_ID': 'Please enter a valid personal ID.',
				'VALID_HOUR': 'You have entered the wrong times. Please enter the correct time in the format hhmm.',
				'VALID_SEATS': 'The seats can not be less than 1.',
				'VALID_PASSWORD_CONFIRM': 'Confirmation of password does not match password.',
				'VALID_EXCHANGE_RATE': 'The exchange rate can not be less than 1.',
				'NO_EMPTY_DATE_FIELDS': 'Date fields are required',
				'VALID_VALUE': 'The value can not be less than 1.',
				'ONLY_NUMBERS': 'The field can contain only numbers',
				'ONLY_STRINGS': 'The field may contain only latin letters',
				'NOT_AUTHORISED': 'The user you are trying to access is invalid',
				'UNABLE_TO_COPY_SEATS_DUE_TO_TAKEN_SEATS': 'Seats may not be copied, because the bus on that date contained busy places.',
				'SAME_STATION': 'Line already has a bus station of the same name.',
				'NO_SELECTED_BUS': 'Please select bus',
				'MULTIPLE_SUBLINES_SEAT_TITLE': 'Multiple sub lines',
				'MULTIPLE_SUBLINES_SEAT': 'There are multiple sub lines reservation for the current seat. If you want ot edit this seat, you have to select the sub line first.'
			},
			'FIND_BUS_BY_DEPARTURE_DATE': 'Search buses by date of departure',
			'FIRST_DRIVER': 'First driver',
			'FROM_TO': 'From-To',
			'FROM': 'Ból ből',
			'FROM_STATION': 'From station',
			'FROM_CITY': 'From city',
			'GOING': 'Going',
			'GOING_SEAT': 'Seat induláskor:',
			'HEADING': {
				'CHANGE_PASSWORD': 'Change password',
				'CREATING_NEW_CITY': 'Creating a new city',
				'CREATING_NEW_LINE': 'Creating a new line',
				'CREATING_NEW_STATION': 'СCreating a new bus station',
				'CREATING_NEW_OFFICE': 'Creating a new office',
				'CREATING_NEW_AGENT': 'Creating a new agent',
				'CREATING_NEW_DISCOUNT': 'Creating a new discount',
				'CREATING_NEW_PROMOTION': 'Creating a new promotion',
				'CREATING_NEW_ADMINISTRATOR': 'Creating a new administrator',
				'CREATING_NEW_CURRENCY': 'Creating a new currency',
				'EDITING_CITY': 'Edit city',
				'EDITING_LINE': 'Edit line',
				'EDITING_STATION': 'Edit station',
				'EDITING_OFFICE': 'Edit office',
				'EDITING_AGENT': 'Edit agent',
				'EDITING_DISCOUNT': 'Edit discount',
				'EDITING_PROMOTION': 'Edit promotion',
				'EDITING_TICKET': 'Edit ticket',
				'EDITING_ADMINISTRATOR': 'Edit administrator',
				'EDITING_CURRENCY': 'Edit currency',
				'PROMOTION_LINES': 'Promotional lines',
				'SEATS_FROM_LINE': 'Lock seats fom line',
				'EDITING_PROMOTION_LINES': 'Edit promotional lines',
				'PRINT_TICKET': 'Print ticket',
				'PRINT_REPORT': 'Print report',
				'BUYING_TICKET': 'Purchasing a ticket'
			},
			'ID_CLIENT_NUMBER': 'ID / client number',
			'CLINET_NUMBER': 'Client number',
			'ID_NUMBER': 'PIN',
			'I_WANT_TO': 'I want to:',
			'MENU': 'Menu',
			'MARK_AS_REPORTED': 'Mark as reported',
			// For bg locale we have a lot of field with name for different languages,
			'NAME_OF': {
				'bg': 'Name',
				'en': 'Name in english'
			},
			'NAME_OF_REVERSE': {
				'bg': 'Name of return line',
				'en': 'Name of return line in english'
			},
			'NAME': 'Név',
			'NAMES': 'Names',
			'NOT_FOUND': {
				'ADMINISTRATORS': 'There are no administrators.',
				'BUSES_BY_LINE': 'You have not added buses on this line.',
				'BUSES_BY_DATE': 'You have not added buses that date.',
				'BUSES_ON_THAT_DATE': 'There are no buses going to that date.',
				'COUNTRY': 'There are no countries.',
				'CITY': 'Nincsenek városokban.',
				'CLIENT': 'There are no clients.',
				'DISCOUNTS': 'There are no discounts.',
				'POINT_IN_LINE': 'There are no stops to the line',
				'PRICE_IN_LINE': 'There are no prices to the line',
				'STATION': 'There are no stops.',
				'RETURN_SUBLINES': 'There are no lines comeback search criteria.',
				'GOING_SUBLINES': 'There are no lines going search criteria.',
				'OFFICES': 'There are no offices.',
				'AGENTS': 'There are no agents.',
				'PROMOTIONS': 'There are no promotions.',
				'SUB_LINES': 'There are no sub lines.',
				'PROMOTIONAL_LINES': 'There are no promotional lines.',
				'SOLD_TICKETS': 'No tickets sold for this bus to this date.'
			},
			'NOT_REPORTED': 'Not reported',
			'NUMBER': 'Number',
			'NEW_PASSWORD': 'New pasword',
			'NOTE': 'Note',
			'REVIEW_NOTE': {
				'INSPECTED': 'Note taking into account',
				'CANCELED': 'Note cancellation'
			},
			'LINE': 'Line',
			'LOADING': 'Loading...',
			'ONE_WAY': 'Egyirányú',
			'PAID': 'Paid',
			'PASSWORD': 'Password',
			'PASSWORD_CONFIRM': 'Password confirm',
			'PRICE': 'Ár',
			'PRICES_FOR_LINE': 'Line prices',
			'PERCENT': 'Percent',
			'PRICE_OF_TICKET': 'Ticket price',
			'TICKET_NUMBER': 'Ticket number',
			'PLEASE_CHOOSE_LINE': 'Please choose line:',
			'PHONE': 'Telefon',
			'PROMOTIONS_FROM_LINE': 'Promotions from line',
			'REMOVE': 'Remove',
			'RESERVED': 'reserved',
			'RETURN': 'Return',
			'RETURN_SEAT': 'Seat on return:',
			'SELECT_CITY': 'Select city',
			'SELECTED_SUB_LINE': 'Choosen bus stops',
			'SEATS': 'Seats',
			'SEAT_NUMBER': 'ülés száma',
			'FREE_SEAT': 'szabad helyek',
			'OCCUPIED_SEAT': 'elfoglalt ülések',
			'PAID_SEAT': 'Paid seats',
			'RESERVED–SEAT': 'Reserved seat',
			'CHOOSEN_SEAT': 'intézni ülés',
			'LOCKED_SEAT': 'Locked seat',
			'SEARCHING': 'Searching...',
			'SET_BUS_HOURS': 'Set bus hours:',
			'SET_BUS_SEATS': 'Set bus seats:',
			'SET_BUS_DAYS': 'Set days when traveling:',
			'SHOW_ALL_SUB_LINE': 'Show all sub lines',
			'BTN': {
				'ADD': 'Add',
				'ADD_NEW_BUS': 'Add bus',
				'ADD_CITY_BTN': 'Add city',
				'ADD_NEW_DISCOUNT': 'Add discount',
				'ADD_NEW_CITY': 'Add new city',
				'ADD_NEW_LINE': 'Add new line',
				'ADD_NEW_STATION': 'Add new station',
				'ADD_NEW_OFFICE': 'Add new office',
				'ADD_NEW_AGENT': 'Add new agent',
				'ADD_NEW_PROMOTION': 'Add new promotion',
				'ADD_NEW_ADMINISTRATOR': 'Add new administrator',
				'ADD_NEW_CURRENCY': 'Add new currency',
				'ADD_STATION': 'Add station',
				'ADD_LINES': 'Add lines',
				'BACK': 'Back',
				'BACK_TO_LAST_PAGE': 'Back to last page',
				'CANCEL': 'Cancel',
				'CANCEL_ALIAS': 'Discard',
				'CHANGE_DATA_GOING': 'Change return data',
				'CHANGE_DATA_RETURN': 'Change going data',
				'CHANGE_PASSWORD': 'Change password',
				'CHANGE_BUS': 'Change bus',
				'LOGIN': 'Login',
				'NEW_CLIENT': 'New client',
				'SAVE': 'Save',
				'SAVE_CHANGES': 'Save changes',
				'SAVE_LINE': 'Save line',
				'SEARCH': 'Keres',
				'EDIT': 'Edit',
				'REMOVE': 'Remove',
				'RESERVE': 'Lefoglal',
				'PRINT': 'Print',
				'PREVIEW': 'Preview',
				'BUY': 'BUY',
				'EDIT_SEAT': 'Edit seat',
				'CONTINUE': 'Folytatódik',
				'DELETE_RESERVATION': 'Delete reservation',
				'CLOSE': 'Close'				
			},
			'SUCCESS': {
				'CREATE_BUS': 'Successfully created a new bus.',
				'CREATE_CITY': 'Successfully created a new city.',
				'CREATE_STATION': 'Successfully created a new bus stop.',
				'CREATE_LINE': 'Successfully created a new line.',
				'CREATE_RESERVATION': 'Successfully created a new reservation.',
				'CREATE_OFFICE': 'Successfully created a new office.',
				'CREATE_AGENT': 'Successfully created a new agent.',
				'CREATE_DISCOUNT': 'Successfully created a new discount.',
				'CREATE_PROMOTION': 'Successfully created a new promotion.',
				'CREATE_ADMINISTRATOR': 'Successfully created a new administrator.',
				'CREATE_CURRENCY': 'Successfully created a new currency.',
				'COPY_BUS': 'Successfully copied bus.',
				'COPY_LINE': 'Successfully copied line.',
				'LINE_ADDED_TO_PROMOTION': 'Successfully added a new line to promotion.',
				'LINE_REMOVED_TO_PROMOTION': 'Successfully removed a line of promotion.',
				'SUB_LINE_ADDED_TO_PROMOTION': 'Successfully added a new sub line to promotion.',
				'SUB_LINE_REMOVED_TO_PROMOTION': 'Successfully removed below the line promotion.',
				'SAVE_LOCKED_SEATS': 'Successfully saved the locked seats.',
				'COPY_LOCKED_SEATS': 'Successfully copied locked seats.',
				'UPDATE_BUS': 'Successfully changed bus.',
				'UPDATE_CITY': 'Successfully changed city.',
				'UPDATE_STATION': 'Successfully changed the station.',
				'UPDATE_LINE': 'Successfully changed line.',
				'UPDATE_OFFICE': 'Successfully changed the office.',
				'UPDATE_AGENT': 'Successfully changed agent.',
				'UPDATE_PRICE': 'Successfully changed the price.',
				'UPDATE_DISCOUNT': 'Successfully changed reduction.',
				'UPDATE_PROMOTION': 'Successfully changed promotion.',
				'UPDATE_PASSWORD': 'Successfully changed password.',
				'UPDATE_TICKET': 'Successfully changed the ticket.',
				'UPDATE_ADMINISTRATOR': 'Successfully changed administrator.',
				'UPDATE_CURRENCY': 'Successfully changed currency.',
				'DELETE_CITY': 'Successfully deleted town.',
				'DELETE_STATION': 'Successfully deleted station.',
				'DELETE_LINE': 'Successfully deleted the line.',
				'DELETE_BUS': 'Successfully deleted bus.',
				'DELETE_DISCOUNT': 'Successfully deleted reduction.',
				'DELETE_OFFICE': 'Successfully deleted office.',
				'DELETE_AGENT': 'Successfully deleted agent.',
				'DELETE_PRICE': 'Successfully deleted cost of the line.',
				'DELETE_PROMOTION': 'Successfully deleted promotion.',
				'DELETE_ADMINISTRATOR': 'Successfully deleted administrator.',
				'DELETE_CURRENCY': 'Successfully deleted currency.',
				'INSPECTED_TICKET': 'Successfully recorded a ticket.',
				'CANCELED_TICKET': 'Successfully canceled tickets.'
			},
			'ONE-WAY': 'Oneway',
			'ONE_PRICE_FOR_ALL_SUB_LINE': 'One price for all sub lines',
			'ON_FIRST_POSITION': 'Paste at the beginning',
			'ON_LAST_POSITION': 'Paste at the end',
			'ON_PRESENT_POSITION': 'Keep current position',
			'COUNTRY': 'Country',
			'SELECT_FROM_EXIST_STATION': 'Choose bus stop fom line',
			'SEE_EDIT_LOCKED_SEATS': 'Look at / change locked seats',
			'SEAT': 'Ülés',
			'SECOND_DRIVER': 'Second driver',
			'SIDEBAR': {
				'ADMINISTRATORS': 'Administrators',
				'AGENTS': 'Agents',
				'BUSES': 'Buses',
				'CITIES': 'Cities',
				'DISCOUNTS': 'Discounts',
				'LOGOUT': 'Logout',
				'LINES': 'Lines',
				'OFFICES': 'Offices',
				'TICKETS': 'Tickets',
				'PRICES': 'Proces',
				'PROMOTIONS': 'Promotions',
				'RESERVATIONS': 'Reservations',
				'STATIONS': 'Bus stops',
				'SALES': 'Sales',
				'SEATS': 'Seats',
				'REPORTS': 'Reports',
				'LOCK_SEATS': 'Seats',
				'WAYBILL': 'Waybill',
				'CURRENCIES': 'Currencies',
				'NEGOTIATED': 'Negotiated seats'
			},
			'SHORT_HOUR': 'h.',
			'SHOW_BUS_SCHEMA': 'Show bus schema',
			'SHOW_WAYBILL': 'Show waybill',
			'SWAP_CITIES': 'Swap cities',
			'STATION': 'Station',
			'SUB_LINES': 'Sub lines',
			'SUB_LINE': 'Sub line',
			'SOLD_FROM': 'Sold from',
			'TITLE': {
				'NEW_CITY': 'New city',
				'NEW_STATION': 'New station',
				'NEW_LINE': 'New line',
				'NEW_OFFICE': 'New office',
				'NEW_AGENT': 'New agent',
				'NEW_DISCOUNT': 'New discount',
				'NEW_PROMOTION': 'New promotion',
				'NEW_ADMINISTRATOR': 'New administrator',
				'NEW_CURRENCY': 'New currency'
			},
			'TICKET': 'Ticket',
			'TICKET_TYPE': 'Ticket type:',
			'TICKET_STATUS': 'Ticket status:',
			'THIRD_DRIVER': 'Third driver',
			'TO': 'Nak nek',
			'TO_CITY': 'To city',
			'TO_STATION': 'To station',
			'TWO_WAY': 'Kétirányú',
			'VALUE': 'Value',
			'INSPECTED': 'inspected',
			'NOT_INSPECTED': 'Uninspected',
			'VALID_FROM': 'Valid from',
			'VALID_TO': 'Valid to',
			'WEEK_DAYS': {
				'EVERYDAY': 'Every day',
				'MONDAY': 'Monday',
				'TUESDAY': 'Tuesday',
				'WEDNESDAY': 'Wednesday',
				'THURSDAY': 'Thursday',
				'FRIDAY': 'Friday',
				'SATURDAY': 'Saturday',
				'SUNDAY': 'Sunday'
			},
			'REPORTED': 'Reported',
			'REPORTS': {
				'MY_REPORTS': 'Show my reports',
				'TICKET': 'Ticket',
				'SEAT': 'Seat',
				'RETURN_SEAT': 'Return seat',
				'TYPE': 'Type',
				'NAME': 'Name',
				'EGN': 'PIN',
				'PRICE': 'Price',
				'DISCOUNT': 'Discount',
				'FROM': 'From',
				'TO': 'To',
				'AGENT_NAME': 'Agent name',
				'TOTAL': 'Total: ',
				'REPORT_PRICE': 'Report price',
				'USER_SEARCH': 'Search user',
				'ONE_WAY': 'O',
				'TWO_WAY': 'T',
				'USER': 'User'
			},
			'REGISTRATION_NUMBER': 'REgistration number',
			'SALES': {
				'ROUTE': 'Route',
				'DEPARTURE': 'Departure',
				'HOUR': 'Hour',
				'DATE_OF_ISSUE': 'DAte of issue',
				'SHOW_TICKET': 'Show ticket'
			},
			'WITHOUT_DISCOUNT': 'levonás nélkül',
			'PUBLIC': {
				'BUS_SEARCH': 'Keresése jegy',
				'BUS_STOPS': 'Es busz: ',
				'NO_RESULT': 'Nincsenek busz megy , hogy a dátumot.',
				'NO_RETURN_RESULT': 'Nincsenek buszok visszatérni ezen a napon .',
				'TIME_HINT': 'Minden időpont helyi',
				'TRAVEL_TO': 'Utazik',
				'WElCOME_TEXT': {
					'HOW': 'Hogyan',
					'WORKS': 'működik'
				},
				'SWAP': 'csere',
				'TITLE': {
					'HOME': 'Menj a főoldalra'
				},
				'STEP': 'Lépés',
				'STEP_ONE_TEXT': 'Ahol az utazás',
				'STEP_1': 'Ahol az utazás',
				'STEP_DESCRIPTION_1': 'Válassza ki, hol utazik , ahol dátum és az utazás.',
				'STEP_TWO_TEXT': 'Válassza ki a legjobb módja',
				'STEP_2': 'Válassza ki a legjobb módja',
				'STEP_DESCRIPTION_2': 'Válassza ki a kívánt helyen , és a rezervtsiyata.',
				'STEP_THREE_TEXT': 'Vásárlás gyors és biztonságos',
				'STEP_3': 'Vásárlás gyors és biztonságos',
				'STEP_DESCRIPTION_3': 'Vásároljon gyorsan és biztonságosan a jegy rendszere révén ePay.',
				'CHOOSE_SEAT_FROM_SCHEMA': '(Válasszon helyet a buszon séma)',
				'WElCOME_TO': 'Üdvözöljük a',
				'BOTTOM_MENU': {
					'TERMS': 'Terms of use',
					'PRIVACY': 'Privacy policy',
					'COOKIE_POLICY': 'Cookie policy'
				},
				'LOGIN_TO_BTMS': 'Belépés a rendszerbe',
				'RETURN_TICKET': 'Retúrjegy',
				'ONE_WAY_TICKET': 'Ticket megy',
				'SHOW_TICKET': 'Mutatása jegy',
				'EPAY_PAYMENT': 'ePay fizetés:',
				'PASSANGER_NAME': 'személyautó neve',
				'THANK_YOU': 'Köszönöm!',
				'SUCCESS_MESSAGE': 'Sikeresen mentette jegyet a buszjáratok.',
				'BON_VOAYAGE': 'Kellemes utazást!',
				'AGENTS_ENTRANCE': 'Bejelentkezés',
				'PAYMENT': 'Fizetés'
			},
			'SET_BASE_CURRENCY': 'Current base currency is set to: ',
			'TEXT_OVER_CHOOSE_BUTTON': 'Choose buses and continue to get a discount for a return ticket.',
			'NEW': {
				'WELCOME': 'Üdvözöljük a " GROUP " LTD и " MODI TRANS " LTD',
				'TRANSPORT': 'Személyszállítás',
				'SOFIA': 'Sofia',
				'BUDAPEST': 'Budapest',
				'BRATISLAVA': 'Bratislava',
				'BRNO': 'Brno',
				'PRAGUE': 'Prague',
				'BUY_IN_THREE_STEPS': 'A jegyeket mindössze három lépésből áll :',
				'DISCOUNT': 'Ha vásárol egy jegyet www.group-ood.com kapsz a következő kedvezmények:'	
			},
			'LINK': 'Link',
			'USER_LINK': 'User link',
			'USER_LINK_COPY': 'Copy to clipboard: Press Ctr+C'
		});
	$translateProvider.useSanitizeValueStrategy(null);
	$translateProvider.use('bg');
}



/** WEBPACK FOOTER **
 ** ./client/private/private.locale.js
 **/